export const espanolMX = {
  firstNameIsInvalid: 'Este campo es obligatorio. Se permite un máximo de 100 caracteres.',
  invalidFirstName: 'Nombre inválido',
  invalidLastName: 'Apellido inválido',
  lastNameIsInvalid: 'Este campo es obligatorio. Se permite un máximo de 100 caracteres.',
  emailIsInvalid: 'Por favor, ingrese una dirección de correo electrónico válida',
  organisationIsInvalid: 'Por favor ingrese máximo 100 caracteres',
  countryCodeIsNotSelected: 'Seleccione su país',
  passwordIsInvalid:
    'La contraseña debe tener entre 12 y 64 caracteres y debe contener al menos una letra mayúscula, una letra minúscula, un número y un símbolo.',
  confirmPasswordInvalid: 'La contraseña y la contraseña de confirmación no coinciden',
  passwordsNoMatchInvalid: 'Las contraseñas no coinciden',
  confirmPasswordEmpty: 'Por favor confirme su contraseña',
  termsAndConditionsNotAccepted: 'Para continuar, lea y acepte los Términos y Uso',
  suchEmailAlreadyInUse: 'Este correo ya está registrado en el sistema',
  successfulRegistration: 'Su cuenta ha sido creada satisfactoriamente. Ahora puede iniciar sesión.',
  somethingWentWrong: 'Algo salió mal, contáctenos (info@keybiodiversityareas.org)',
  passwordHint:
    'La contraseña debe tener entre 12 y 64 caracteres y debe contener al menos una letra mayúscula, una letra minúscula, un número y un símbolo',
  previousPasswordCantBeUsed: 'No se puede utilizar la contraseña anterior',
  alreadyUsedOrExpired: 'El enlace de restablecimiento de contraseña ha caducado o ya se ha utilizado',
  firstNameLabel: 'Primer nombre',
  email: 'Correo electrónico',
  password: 'Contraseña',
  lastNameLabel: 'Apellido ',
  emailLabel: 'Correo electrónico',
  organisationLabel: 'Organización',
  countryLabel: 'País',
  countryOfInterestLabel: 'País de interés',
  interestSelectIsMandatory: 'Seleccione su país de interés del menú desplegable',
  numberOfKba: 'Número de sitios',
  triggerSpecies: 'Especies activadoras',
  kbaPartner: 'Socio KBA',
  kbaPartnerLabel: 'Socio KBA',
  passwordLabel: 'Contraseña',
  confirmPasswordLabel: 'Confirmar contraseña',
  termsAndConditionsText: 'Estoy de acuerdo con',
  categoryDropdown: 'Menú desplegable de categorías',
  allCategories: 'Todas las categorias',
  createAccountButton: 'Crear una cuenta',
  firstNamePlaceholder: 'Ingrese su primer nombre',
  lastNamePlaceholder: 'Ingrese su apellido',
  emailPlaceholder: 'Ingrese su correo electrónico',
  searchPlaceholder: 'Búsqueda...',
  organisationPlaceholder: 'Organización',
  passwordPlaceholder: 'Ingrese su contraseña',
  newPasswordPlaceholder: 'Ingrese su nueva contraseña',
  confirmPasswordPlaceholder: 'Confirmar la contraseña',
  confirmNewPasswordPlaceholder: 'Confirme su nueva contraseña',
  enterAndConfirmNewPassword: 'Por favor ingrese y confirme la nueva contraseña',
  countryPlaceholder: 'Seleccione su país',
  countryOfInterestPlaceholder: 'Seleccione su país principal o países de interés',
  kbaPartnerPlaceholder: 'Seleccione la afiliación de socio de KBA (si corresponde)',
  alreadyHaveAnAccount: '¿Ya tiene una cuenta?',
  signIn: 'Iniciar sesión',
  signUp: 'Registrarse',
  signOut: 'Cerrar sesión',
  dontHaveAnAccount: '¿No tienes una cuenta?',
  changePassword: 'Cambia la contraseña',
  rememberMeCheckbox: 'Recuérdame',
  forgotPassword: '¿Olvidó su contraseña?',
  pleaseEnterYourCredentials: 'Por favor ingrese sus credenciales',
  pleaseEnterYourEmail: 'Por favor ingrese su correo electrónico',
  emailOrPasswordIncorrect: 'Correo electrónico o contraseña no válidos',
  resetPassword: 'Restablecer la contraseña',
  rememberYourPassword: 'Recuerda su contraseña',
  passwordChangeSuccessful: 'Su contraseña fue cambiada con éxito',
  assessmentsHint: 'Todas las evaluaciones {assessmentNumber}',
  allAssessments: 'Todas las evaluaciones {assessmentsNumber}',
  reassessSite: 'Evaluar la biodiversidad',
  resetPasswordSuccessful:
    'Si este registro existe, recibirá un correo electrónico con instrucciones sobre cómo restablecer su contraseña en unos minutos.',
  roleSelectLabel: 'Rol',
  roleSelectPlaceholder: 'Seleccionar rol',
  roleSelectIsMandatory: 'Seleccione su rol del menú desplegable',
  pleaseEnterNewPassword: 'Por favor ingrese una nueva contraseña',
  propose: 'Propuesta',
  proposeSite: 'Agregar un sitio nuevo',
  editProfile: 'Editar perfil',
  profile: 'Mi perfil',
  accountSettings: 'Configuraciones de la cuenta',
  terms: 'Términos de Uso',
  privacy: 'Política de privacidad',
  dashboard: 'Dashboard',
  sites: 'Sitios',
  users: 'Usuarios',
  monitoring: 'Vigilancia',
  forum: 'Forum',
  activeUsers: 'Usuarios activos',
  noMatchingFilterCriteria: 'Ningún usuario coincide con los criterios de filtrado',
  clearFilters: 'Borrar filtros',
  moldova: 'Moldova',
  ncg: 'Grupo Nacional de Coordinación',
  notifications: 'Notificaciones',
  nothingHereSoFar: 'Nada aquí hasta ahora...',
  proposerName: 'Nombre del proponente',
  proposerEmail: 'Correo electrónico del proponente',
  noSensitiveSitesFound: 'No se encontraron sitios sensibles',
  individual: 'Individual',
  // ecoRegionMapHint: '',
  '/terms-and-use': 'Términos de Uso',
  '/users': 'Gestión de usuarios',
  '/sites': 'Gestión de sitios',
  '/profile': 'Configuración de perfil',
  'registrationPage.pageTitle': 'Registro',
  showing: 'Demostración',
  secretariat: 'Secretaría',
  name: 'Apellido nombre',
  country: 'País',
  countryOfInterest: 'País de interés',
  role: 'Tipo de usuario',
  userStatus: 'Estado',
  lastLogin: 'Último acceso',
  actions: 'Acciones',
  date: 'Date',
  time: 'Time',
  usersAndAssessment: 'Users and Assessments',
  siteNameNational: 'Nombre del sitio (nacional)',
  siteNameInternational: 'Nombre del sitio (internacional)',
  siteNameEng: 'Nombre del sitio (internacional)',
  year: 'Año',
  yearOfEstimate: 'Year of estimate',
  proposer: 'Proponente',
  siteStatus: 'Estado',
  noSitesMatchFilteringCriteria: 'Ningún sitio coincide con los criterios de filtrado',
  nothingMatchesYourSearch: 'Nada coincide con su búsqueda',
  clearResults: 'Borrar resultados de búsqueda',
  searchUserPlaceholder: 'Nombre, país o tipo de usuario...',
  search: 'Búsqueda',
  home: 'Hogar',
  lastName: 'Apellido',
  firstName: 'Primer nombre',
  newPassword: 'Nueva contraseña',
  confirmNewPassword: 'Confirme su nueva contraseña',
  enterCurrentPassword: 'Ingrese su contraseña actual',
  enterNewPassword: 'Ingrese su nueva contraseña',
  cancel: 'Cancelar',
  enterOldPassword: 'Por favor, ingrese su contraseña',
  changeEmail: 'Cambiar correo electrónico',
  emailConfirmation: 'Correo electrónico de confirmación',
  changeEmailConfirmation:
    'Para terminar de cambiar su dirección de correo electrónico, le enviamos un correo electrónico a {email}, simplemente haga clic en el enlace del correo electrónico para completar el proceso.',
  emailWasChanged: 'Su nueva dirección de correo electrónico ha sido confirmada',
  emailChanged: 'Cambio de correo electrónico confirmado',
  saveChanges: 'Guardar cambios',
  deleteProfile: 'Borrar perfil',
  changeButton: 'Cambio',
  pendingButton: 'Pendiente',
  goBack: 'Regresar',
  edit: 'Editar',
  editComment: 'Editar comentario',
  removeComment: '¿Quitar comentario?',
  monitorSite: 'Monitor site',
  block: 'Bloquear',
  loginPageDescription: 'Base de Datos Global de Áreas Clave para la Biodiversidad',
  loginBottomImageDescription: 'Honduras Spikethumb Frog (Plectrohyla dasypus) © Andrew Snyder / Re:wild',
  addNewCoProposer: 'Añadir nuevo co-proponente',
  inviteCoProposers: 'Invitar a coproponentes',
  enterSitename: 'Ingrese el nombre del sitio',
  sendInvites: 'Enviar invitaciones',
  pleaseEnterCurrentPassword: 'Por favor ingrese la contraseña actual',
  manage: 'Administrar',
  remove: 'Remover',
  about: 'Acerca de',
  nameAndLocation: 'Nombre y ubicación',
  nameAndLocationDescription: 'Nombre y ubicación del sitio.',
  assessment: 'Evaluación',
  invite: 'Invitar',
  manageUsers: 'Administrar usuarios',
  categoryDropdownPlaceholder: 'Categoría',
  draft: 'Borrador',
  submitProposal: 'Proponer evaluación',
  yourSiteProposalIsInDraft: 'Su evaluación está en estado Borrador y no ha sido propuesta',
  totalUsers: 'Total de usuarios',
  siteProposalHasBeenSuccessfully: 'Site proposal has been successfully saved as draft',
  inviteCoProposersModalTitle: 'Invitar a coproponentes',
  enteredEmailAlreadyInUse: 'Este correo ya está registrado en WDKBA',
  profileSuccessfullySaved: 'Tú perfil ha sido actualizado satisfactoriamente',
  nominate: 'Nominar',
  nominateSite: 'Nominar evaluación',
  submitEvaluation: 'Enviar evaluación',
  nominateSiteText: '¿Está seguro de que desea nominar la evaluación propuesta en el sitio {siteName}?',
  confirmAssessmentBtn: 'Confirmar evaluación',
  confirmAssessment: '¿Confirmar evaluación?',
  confirmAssessmentText: '¿Está seguro de que desea confirmar esta evaluación nominada para {siteName}?',
  approveEditsText:
    '¿Está seguro de que desea enviar los cambios realizados en {siteName}? Esta acción no se puede deshacer y sus modificaciones se enviarán para su aprobación.',
  rejectBtn: 'Rechazar',
  rejected: 'Rechazar',
  delistBtn: 'Eliminar de la lista',
  delist: 'Eliminar de la lista',
  doesNotQualify: 'No califica',
  setDoesNotQualify: 'Asignar el estado No califica',
  delistAssessment: '¿Eliminar sitio de la lista?',
  doesNotQualifyModal: '¿No califica la evaluación?',
  doesNotQualifyText:
    '¿Está seguro de que desea cambiar el estado del sitio para {siteName} a No califica? Esta operación no se puede deshacer.',
  rejectAssessmentBtn: 'Rechazar evaluación',
  rejectAssessment: '¿Rechazar evaluación?',
  rejectEdits: 'Rechazar ediciones',
  delistAssessmentText: 'Estás seguro de que quieres eliminar este sitio: {siteName}?',
  rejectAssessmentText:
    '¿Está seguro de que desea rechazar la evaluación de {siteName}? La evaluación volverá al estado de borrador y se notificará al Proponente. Asegúrese de que se hayan proporcionado comentarios que reflejen los cambios necesarios.',
  rejectEditsText:
    '¿Está seguro de que desea eliminar las ediciones realizadas en {siteName}? Esta acción no se puede deshacer y los detalles volverán a ser los aprobados durante la última sesión de evaluación o edición.',
  nominateAssesment: '¿Nominar evaluación?',
  approve: 'Aprobar',
  approveForNomination: '¿Aprobar para la nominación?',
  approveForNominationText: '¿Está seguro de que desea aprobar la evaluación propuesta {siteName} para su nominación?',
  manageUser: 'Administrar usuario',
  decline: 'Rechazar',
  discardChanges: '¿Descartar los cambios?',
  yesCancel: 'Sí, cancelar',
  returnToDraft: 'Volver al borrador',
  returnToEditOnly: 'Rechazar ediciones',
  returnDraft: '¿Volver al borrador?',
  declineFeedback: 'Retroalimentación',
  declineAssessment: '¿Devolver comentarios?',
  returnFeedbackText:
    '¿Está seguro de que desea devolver la evaluación propuesta {siteName} en busca de más aclaraciones o detalles? Asegúrese de que sus razones se presenten claramente en sus comentarios de revisión.',
  returnDiscardChangesText:
    '¿Está seguro de que desea descartar la reevaluación de {specieName}? Se descartarán todos los cambios y se restablecerá la evaluación anterior de esta especie.',
  categoryName: 'Nombre',
  organization: 'Organización',
  userType: 'Tipo de usuario',
  status: 'Estatus',
  viewSite: 'Ver sitio',
  viewAll: 'Ver todo',
  pending: 'Pendiente',
  passwordHasExpired: 'La contraseña ha caducado',
  currentPassword: 'Contraseña actual',
  youHaveToChangePassword: 'Cambie su contraseña. No podrá acceder al sistema hasta que cambie su contraseña.',
  enterYourPassword: 'Ingrese su contraseña',
  confirmNewPasswordEmpty: 'Por favor, confirme su contraseña',
  threatenedBiodiversity: 'Biodiversidad amenazada',
  geographicallyRestrictedBiodiversity: 'Biodiversidad restringida geográficamente',
  ecologicalIntegrity: 'Integridad ecológica',
  irreplaceabilityThroughQuantitiveAnalysis: 'Irreemplazabilidad a través del análisis cuantitativo',
  biologicalProcesses: 'Procesos biológicos',
  nameContactDetails: 'Nombre, detalles de contacto',
  provideReviewersInfoWhoCanCommentOnYourProposal:
    'Ingrese detalles de los revisores que pueden comentar sobre esta evaluación (sus nombres y detalles de contacto)',
  restrictedRangeStatus: 'Estatus de Rango Rest.',
  criteria: 'Criterios de la Lista Roja de la UICN',
  redListCrit: 'Criterio de la Lista Roja',
  aboutPageTitle: 'Acerca de la propuesta',
  aboutPageSubTitle: 'Criterios KBA evaluados',
  ongoingConservationActionsAtSite: 'Acciones de conservación en curso en el sitio',
  aboutProposalHint:
    'Indique los criterios que está aplicando en el sitio, incluso si el sitio no cumplió con todos estos. Si está aplicando el Criterio E, comuníquese con el Secretariado de KBA [hyperlink to info@keybiodiversityareas.org] para obtener detalles sobre lo que se requiere.',
  monitoringPageTitle: 'Monitoreo',
  noSpeciesMatchFilteringCriteria: 'Ningún sitio coincide con los criterios de filtrado',
  nationalSiteName: 'Ingrese el nombre del sitio nacional',
  internationalSiteName: 'Ingrese el nombre del sitio internacional',
  stateProvince: 'Estado o provincia (si corresponde)',
  stateProvincePlaceholder: 'Ingrese el estado o provincia',
  siteArea: 'Área del sitio (km2)',
  siteAreaPlaceholder: 'Ingrese el área del sitio (en km2)',
  latitude: 'Latitud (grados dec.)',
  latitudePlaceholder: 'Ingrese la latitud del centroide (en grados decimales)',
  longitude: 'Longitud (grados dec.)',
  longitudePlaceholder: 'Ingrese la longitud del centroide (en grados decimales)',
  coveredByPa: 'Cobertura por AP (% calculado a partir de la WDPA)',
  coveredByPaTemplate: 'Cobertura por AP (% banda)',
  coveredByOECMTemplate: 'Cobertura por OMEC (% banda)',
  supersededSitesDesription: 'Details about KBAs that will replaced by others',
  coveredByPaPlaceholder: 'Valor para el % cubierto por AP',
  reviewersContactsThatCanComment: 'Revisores que pueden comentar sobre esta evaluación',
  coveredByPaHint:
    '% cubierto por Áreas Protegidas calculado a partir de una superposición con Áreas Protegidas definidas en la WDPA {hyperLink}',
  coverageArea: 'Cobertura de los OMEC',
  coveredByOECM: 'Cobertura de los OMEC (% calculado)',
  coveredByOECMPlaceholder: 'Valor para el % cubierto por OMEC',
  coveredByOECMHint:
    '% cubierto por otras medidas efectivas de conservación de áreas (OECM) calculado a partir de una superposición con OMEC en la WDPA {hyperLink}',
  habitatsLand: 'Hábitats y uso de la tierra',
  habitatsLandDescription: 'Hábitats y regímenes de uso de la tierra',
  pressures: 'Presiones',
  pressuresDescription: 'Detalles sobre presiones y amenazas',
  additionalDetails: 'Detalles adicionales',
  additionalDetailsDescription: 'Detalles adicionales relacionados con el sitio',
  threats: 'Presiones',
  threatsDescription: 'Descripción de presiones',
  threatsDescriptionTemplate: 'Descripción de presiones y amenazas en el sitio',
  threatsDescriptionHint:
    'Por favor, proporcione una descripción general de las presiones y amenazas (aquellas presiones que afectan a los elementos de biodiversidad de importancia en el sitio) en el sitio',
  threatsDescriptionPlaceholder: 'Describir las presiones y amenazas presentes en el sitio.',
  lowestElevation: 'Elevación más baja (m)',
  lowestElevationPlaceholder: 'Ingrese la elevación más baja en metros',
  highestElevation: 'Elevación más alta (m)',
  highestElevationPlaceholder: 'Ingrese la elevación más alta en metros',
  uploadFile: 'Upload file',
  uploadFilePlaceholder: 'Upload GIS file',
  systemLargest: 'Sistema más grande',
  system2Largest: 'Sistema (segundo más grande)',
  system3Largest: 'Sistema (tercero más grande)',
  systemLargestPlaceholder: 'Seleccione el sistema más grande',
  system: 'Sistema',
  secondLargestSystemPlaceholder: 'Seleccione el segundo sistema más grande',
  thirdLargestSystemPlaceholder: 'Seleccione el tercer sistema más grande',
  smallestSystemPlaceholder: 'Seleccione el sistema más pequeño',
  rationale: 'Justificación (identificación de KBA)',
  rationalePlaceholder: 'Ingrese una justificación de por qué este sitio se propone como KBA',
  siteDescription: 'Descripción del sitio',
  siteDescriptionPlaceholder: 'Ingrese la descripción detallada del sitio',
  manageability: 'Manejabilidad',
  manageabilityFieldTemplate: '¿Cómo se maneja o  potencialmente se maneja el sitio?',
  siteManagedPlaceholder: 'Describa cómo se maneja el sitio.',
  protectedConserved: 'Áreas protegidas o conservadas',
  protectedConservedDescription: 'Extensión de la cobertura del sitio por áreas protegidas o conservadas',
  supersidedSites: 'Sitios reemplazados',
  supersidedSitesHint:
    'Si está creando un nuevo sitio que está reemplazando una o más KBA existentes, por ejemplo si está fusionando o dividiendo las KBA actuales, enumere las KBA que se están reemplazando - se reemplazarán cuando se confirme su sitio',
  supersidedSitesPlaceholder: 'Enumere las KBA existentes que están siendo reemplazados por su nuevo sitio',
  delineation: 'Delimitación',
  delineationRationale: 'Ingrese una explicación de cómo se delimitó el sitio',
  delineationPlaceholder: 'Ingrese una explicación de cómo se delimitó el sitio',
  siteCoverage: 'Cobertura por AP',
  siteCoveragePlaceholder: 'Seleccione la banda de %',
  protectedArea: 'AP y/o OMEC cubiertos',
  protectedAreaPlaceholder: 'Enumere todas las AP y/o OMEC cubiertas por KBA',
  biodiversityValues: 'Valores de la biodiversidad',
  biodiversityValuesPlaceholder: 'Enumere cualquier especie o ecosistema adicional que se encuentre en el sitio',
  siteValues: 'Valores del sitio',
  siteValuesPlaceholder:
    'Enumere los grupos indígenas que tienen derechos consuetudinarios en el sitio y describa los recursos',
  landUse: 'Uso de suelo',
  landUsePlaceholder: 'Describir los regímenes de uso del suelo en el sitio.',
  habitatDescription: 'Descripción general de hábitats',
  habitatDescriptionTemplate:
    'Descripción de hábitats, cuando sea posible utilizando la clasificación de hábitats de la UICN',
  habitatPlaceholder: 'Describa los hábitats presentes',
  habitatHint:
    'Proporcione una descripción general de los hábitats presentes; esto se publicará en las hojas informativas de KBA',
  notes: 'Información Adicional',
  notesTemplate: 'Cualquier otro detalle relacionado con el sitio',
  notesPlaceholder: 'Proporcionar cualquier otra información relacionada con el sitio.',
  references: 'Referencias',
  referencesTemplate: 'Referencias relacionadas con la evaluación (y/o el sitio)',
  referencesPlaceholder: 'Ingrese detalles de las fuentes de información (citas, URL, enlaces a artículos)',
  referencesHint:
    'Ingrese detalles de las fuentes de información (citas, URL, enlaces a artículos) que se relacionen con este sitio',
  siteName: 'Nombre del sitio (internacional)',
  natureOfOccurence: 'Naturaleza de la ocurrencia',
  sensitiveAtSiteLabel: 'Especies Sensibles',
  sensitiveAtSiteSource: 'Proporcione más detalles sobre la sensibilidad de las especies en este sitio',
  sensitiveAtSiteSourcePlaceholder: 'Describa las razones por las que esta especie debe tratarse como sensible en este sitio',
  sensitiveAtSiteSourceRequired: 'La fuente es requerida cuando "Sensible en el Sitio" está habilitado',
  sensitiveAtSiteHint: 'Esta especie debe tratarse como sensible en este sitio',
  ibaRelated: 'Otras condiciones de criterios relacionados con IBA',
  ibaRelatedCriteriaHint:
    "Seleccione cuidadosamente cuáles de las declaraciones relacionadas con los criterios de IBA se aplican en este sitio. Las declaraciones pertinentes son necesarias para activar los respectivos criterios de IBA. Por favor, proporcione más justificación para su(s) selección(es) en 'Detalles adicionales' a continuación.",
  siteNameEnglishHint: 'Ingrese un nombre en inglés reconocido para el sitio',
  siteNameNationalHint: 'Dar un nombre nacional para el sitio',
  countryHint: 'Seleccione el país o países de la lista y haga clic en Aplicar',
  stateProvinceHint: 'Indique el estado o provincia del país donde se encuentra este sitio, si corresponde',
  siteAreaHint:
    'Área del sitio propuesto (km2) - si se mide desde el archivo de forma, debe proyectarse utilizando proyecciones de área igual cilíndrica y datum WGS84',
  latitudeOfCentroidHint: 'Proporcionar centroide de Latitud - en grados decimales con datum WGS84',
  longitudeOfCentroidHint: 'Proporcionar el centroide de Longitud - en grados decimales con datum WGS84',
  lowestElevationHint: 'Dar la elevación en metros',
  highestElevationHint: 'Dar la elevación en metros',
  altitudeOfBathymetryHint: '',
  uploadFileHint:
    'You must attach a boundary file for new or revised KBA boundaries. Existing ones with no change do not need a new file.',
  systemHint:
    'Seleccione el tipo de sistema que mejor refleje los elementos desencadenantes para los que el sitio cumple los requisitos. Por ejemplo, si el sitio solo alberga especies de peces que están restringidas a las partes de agua dulce del sitio, seleccione Agua dulce; si el sitio también alberga un elemento desencadenante una libélula que también depende de hábitats terrestres, añada terrestre como una selección independiente (por ejemplo, en la siguiente casilla de sistema (el segundo más grande, etc.)',
  rationaleHint:
    'Escriba aquí un texto de la justificación de por qué el sitio se propone como KBA. Este texto se incluirá en las hojas informativas del sitio. En el caso de la redelineación de una KBA existente, el texto en este campo puede ser breve y estandarizado, pero debe ser apropiado para su publicación en la WDKBA y en IBAT. Aparte de "KBA", por favor, explique cualquier acrónimo utilizado en los campos incluidos en las hojas informativas en la primera mención de cada sitio.',
  siteDescriptionHint:
    'Escriba un texto sobre el sitio (hábitats principales, rango de altitud, dónde ocurre y cualquier cosa por la que sea conocido); este texto aparecerá en las hojas informativas que se encuentran en la WDKBA. Cada hoja informativa debe ser independiente, incluso si esto significa duplicar parte del texto en todos los sitios. Evite las referencias cruzadas al texto en otros sitios (p. ej., "consulte la hoja informativa para XXX KBA"), ya que ese texto puede actualizarse en el futuro y no podemos rastrear las referencias cruzadas. Si un sitio está siendo reevaluado y no hay cambios, puede indicar que este texto permanece como antes.',
  siteManagedHint:
    'Escriba un texto de por qué cree que el sitio es manejable como una sola unidad; este texto aparecerá en las hojas informativas que se encuentran en la WDKBA.',
  delineationHint:
    'Para todos los sitios nuevos o KBA existentes con un polígono propuesto nuevo o revisado, ingrese una explicación de cómo se delineó el sitio. Esto puede ser breve y bastante estandarizado. Si la delimitación del sitio está alineada con el límite nacional o un área protegida existente, ingrese una referencia para la fuente de datos espaciales (p. ej., GADM, WDPA) y el nombre del área protegida. (No siempre será obvio a partir del nombre de la KBA si la KBA es más pequeña o más grande).',
  siteCoverageHint: 'Seleccione la banda de % que mejor refleje la extensión de la cobertura del sitio por AP',
  biodiversityValueHint:
    'Enumere cualquier especie o ecosistema adicional que se encuentre en el sitio y dé un valor adicional al sitio.',
  siteValueHint:
    'Indique si el sitio incluye tierra, agua u otros recursos pertenecientes a pueblos indígenas o sujetos a derechos de uso consuetudinario. Enumere los grupos indígenas que tienen derechos consuetudinarios en el sitio',
  landUseHint: '¿Cómo se maneja actualmente la tierra en el sitio?',
  notesHint: 'Proporcionar cualquier otra información relacionada con el sitio.',
  protectedAreaHint:
    'Enumere las áreas protegidas y/o los OMEC que cubren el sitio junto con sus números de identificación WDPA disponibles en Protected Planet',
  notification: 'Notificaciones',
  expand: 'Expandir',
  collapse: 'Colapsar',
  system2ndLargest: 'Segundo Sistema más grande',
  system3rdLargest: 'Tercer Sistema más grande',
  systemSmallest: 'Sistema más pequeño',
  congregatoryGroup: 'Grupo congregatorio',
  ecoregion: 'Ecorregión',
  searchEcoRegionName: 'Buscar nombre de ecorregión',
  ecoRegionHint:
    'Ingrese detalles de su evaluación de integridad ecológica aquí; Ingrese el informe adjunto directamente a su punto focal regional {hyperLink}',
  criterionC: 'Integridad ecológica',
  criterionCSubTittle: 'Detalles de la evaluación de la integridad ecológica en el sitio',
  irreplaceability: 'Irremplazabilidad',
  irreplaceabilitySubTittle: 'Detalles de irreemplazabilidad en el sitio',
  irreplaceabilityHint:
    'Comuníquese con su RFP y el Secretariado de KBA directamente con su documentación de evaluación de irremplazabilidad. Una vez que se haya aprobado la evaluación, puede marcar la casilla a continuación para indicar que su evaluación de irremplazabilidad ha sido aprobada y que este sitio cumple con el Criterio E de KBA',
  enterIrreplaceabilityScore: 'Ingrese la puntuación de irreemplazabilidad',
  irreplaceabilityScore: 'Puntuación de irreemplazabilidad',
  irreplaceabilityScoreHint: 'Ingrese su puntuación de irreemplazabilidad',
  enterAssessmentDate: 'Ingrese el año de evaluación',
  irreplaceabilityAssessmentDateHint: 'Por favor ingrese el año de la evaluación',
  checkboxIrreplaceability: 'Evaluación de irremplazabilidad aprobada, el sitio cumple con el Criterio E',
  irreplaceabilityCheckboxHint:
    'Marque la casilla cuando su evaluación de irremplazabilidad haya sido revisada y aprobada por la RFP y la Secretaría de KBA',
  irreplaceabilityCheckboxLabel: 'Evaluación de irremplazabilidad',
  irreplaceabilityAssessmentDateLabel: 'Año de evaluación',
  ecoRegionSite: 'Número de sitios',
  enterNumberOfCriterionCSites: '¿Cuántos sitios cumplen el Criterio C para esta ecorregión?',
  assessmentDate: 'Año de evaluación de la integridad ecológica',
  assessmentDateEx: 'Ingrese el año de la evaluación',
  assessmentDateEco: 'Año de los datos del ecosistema',
  assessmentDateEcoPlaceholder: 'Ingrese el año de los datos del ecosistema',
  enterEvidenceForLowHumanImpact: 'Proporcionar evidencia de bajo impacto humano',
  enterEvidenceForIntactEcologicalCommunities: 'Proporcionar evidencia de comunidades ecológicas intactas',
  criteriaAssessed: 'Criterios evaluados',
  ecosystemName: 'Nombre del ecosistema',
  ecosystemCodeNumber: 'Code number',
  ecosystemCategory: 'Categoría de la Lista Roja de Ecosistemas de la UICN',
  ecosystemGlobalExtent: 'Extensión global (km2)',
  ecosystemExtent: 'Extensión mínima en el sitio (km2)',
  ecosystemExtentBest: 'Mejor estimación de la extensión en el sitio (km2)',
  ecosystemExtentMax: 'Extensión máxima en el sitio (km2)',
  ecosystemDataTable: 'Ecosistemas',
  ecosystemDataTableSubTitle: 'Ecosistemas que activan los criterios KBA',
  ecosystemDataTableHint: '',
  otherCriteriaDataTable: 'Otros criterios',
  otherCriteriaDataTableDescription: 'Evaluación del Criterio C o Criterio E en el sitio',
  source: 'Fuente',
  sourceGlobal: 'Fuente (estimaciones globales)',
  enterEcosystemName: 'Proporcionar un nombre para el ecosistema.',
  codeNumberEx: 'E.g 00005',
  selectEcosystemCategory: 'Seleccione la categoría de la Lista Roja de Ecosistemas de la UICN',
  enterGlobalExtent: 'Ingrese la mejor estimación de la extensión global',
  enterSiteMinExtent: 'Ingrese la extensión mínima en el sitio (si está disponible)',
  enterSiteBestEstimateExtent: 'Ingrese la mejor estimación de la extensión en el sitio',
  enterSiteMaxExtent: 'Ingrese la extensión máxima en el sitio (si está disponible)',
  enterSourceOfEcosystemData: 'Ingrese detalles sobre la fuente de los datos del ecosistema.',
  ecosystemData: 'Datos del ecosistema',
  ecosystemSubTittle: 'Detalles de los ecosistemas evaluados en el sitio',
  commentsPlaceholder: 'Deje sus comentarios aquí...',
  newEcosystem: 'Nuevo ecosistema',
  collapseGroup: 'Ocultar grupo',
  commentsHint:
    'Seleccione una nueva categoría o un hilo de discusión existente a continuación y ingrese sus comentarios',
  commentsTextArea: 'Comentar el área de texto',
  comments: 'Comentarios',
  leaveComment: 'Comentario',
  expandGroup: 'Expandir grupo',
  ecoRegionSiteHint: '¿Cuántos otros sitios han demostrado cumplir con el Criterio C en esta ecorregión?',
  ecoIntegrityHuman: 'Ingrese una descripción de texto que justifique que el sitio tiene un bajo impacto humano',
  ecoIntegrityIntact:
    'Ingrese una descripción de texto que justifique que el sitio tiene comunidades ecológicas intactas',
  assessmentDateHint:
    'Año en que se realizó la evaluación de la integridad ecológica. Si utiliza datos anteriores al año de evaluación real, indique el año de los datos.',
  speciesDetailsForm: 'Especies',
  speciesDetails: 'Especies',
  speciesAtSite: 'Especies en el sitio',
  speciesDetailsSubTittle: 'Detalles de las especies evaluadas en el sitio',
  searchByScientificName: 'Buscar por nombre científico...',
  addSpecies: 'Agregar especies',
  ecoIntegrityLowHumanImpact: 'Evidencia de bajo impacto humano',
  ecoIntegrityEvidenceForIntact: 'Evidencia de comunidades ecológicas intactas',
  speciesList: 'Su selección de especies',
  speciesAssessment: 'Evaluación de especies',
  removeSpecies: '¿Quitar especies?',
  removeEcosystem: '¿Eliminar esta evaluación?',
  yesRemove: 'Sí, eliminar',
  ecosystemNameHint: 'Proporcionar un nombre para el ecosistema.',
  iucnMemberHint: 'Please indicate which group(s)?',
  kbaPartnerHint: '¿Representa a una o más organizaciones socias de KBA?',
  ecosystemCodeNumberHint:
    'Complete this section if assessing the site against ecosystems criteria A2 or B4. If known put the WDKBA ecosystem code here. Put the ecosystem element at the site on a new row - do not put it on the same row as a species element',
  ecosystemCategoryHint: 'Dar Categoría de Lista Roja de la Lista Roja de Ecosistemas',
  ecosystemGlobalExtentHint:
    'Área global del ecosistema - mida utilizando la proyección Cilíndrica de Igual Área y WGS84 (km2)',
  ecosystemExtentHint:
    'Ingrese el área mínima del ecosistema en el sitio (en km2) - mida usando la proyección Cilíndrica de Igual Área y WGS84 (km2)',
  ecosystemExtentBestHint:
    'Ingrese la mejor área de ecosistema en el sitio (en km2) - mida usando la proyección Cilíndrica de Igual Área y WGS84. Si solo están disponibles las extensiones mínima y máxima, Ingrese una estimación de la mejor como el punto medio de la extensión mínima y máxima',
  ecosystemExtentMaxHint:
    'Ingrese el área máxima del ecosistema en el sitio (en km2) - mida usando la proyección Cilíndrica de Igual Área y WGS84 (km2)',
  ecosystemAssessmentDateHint:
    'Año en que se realizó la evaluación - si se basa en imágenes, este debe ser el año de la imagen (se pueden proporcionar más detalles en el campo Fuente a continuación)',
  acknowledgementText:
    'Administrado por BirdLife Internacional en nombre de la Alianza KBA y desarrollado con el generoso apoyo de la Fundación Garfield Weston y el Fondo para la Tierra  Bezos, y también por The Marks Family Charitable Trust, RSPB y otros donantes.',
  ecosystemSourceHint: 'Ingrese más detalles sobre la(s) fuente(s) de datos globales y del sitio utilizados',
  scientificName: 'Nombre científico',
  noteLabel: 'Detalles adicionales (estimaciones del sitio)',
  commonName: 'Nombre común',
  taxonomicGroup: 'Grupo taxonómico',
  taxonId: 'ID del taxón',
  taxonid: 'ID del taxón',
  isTaxonomicGroupPrepopulated: '¿El grupo taxonómico está prepoblado?',
  phylumName: 'Phylum',
  className: 'Clase',
  orderName: 'Orden',
  familyName: 'Familia',
  category: 'Categoría de la Lista Roja de la UICN',
  rangeRestricted: 'Rango restringido',
  rangeRestrictedHint:
    'Especifique si la especie tiene una distribución restringida como se describe para el Criterio B2 en el Estándar KBA, y para algunas especies es específica de la estación. Las especies que carecen de Evaluaciones de la Lista Roja Global de la UICN no se reconocerán como de rango restringido; comuníquese con el Secretariado de KBA {mailTo} si tiene alguna consulta sobre la clasificación asignada a esta especie.',
  possiblyExtinct: 'Posiblemente extinto',
  determined: 'Determinado',
  ecoBioRegionRestricted: 'Restringido a una Ecorregión/Bioregión',
  ecoRegionNameMap: 'Ecorregión y mapa',
  ecoRegionNameMapPlaceholder: '',
  bioRegionNameMap: 'Bioregión y mapa',
  bioRegionNameMapPlaceholder: '',
  assessmentSystem: 'Sistema de evaluación',
  evidence: 'Evidencia de presencia',
  unitsNumber: 'Número mínimo de unidades reproductivas (UR)',
  comprised: 'Definir 10 UR para esta especie',
  enterSpeciesCommonName: 'Enter species Common name',
  enterSpeciesTaxonomicGroup: 'Enter species Taxonomic group',
  selectSpeciesRedListCategory: 'Seleccionar la Categoría de la Lista Roja de la especie ',
  selectEquivalentSystem: 'Seleccionar sistema equivalente',
  selectSpeciesRedListCriteria: 'Select species Red list criteria',
  rangeRestrictionDeterminedBy: 'Range restriction determined by',
  enterEcoRegionName: 'Enter Ecoregion name',
  enterEcoRegionMapUsed: 'Select Ecoregion map used',
  enterBioRegionName: 'Enter Bioregion name',
  enterBioRegionMapUsed: 'Select Bioregion map used',
  speciesRedListHint:
    'Si esta especie no tiene una evaluación global de la Lista Roja de la UICN y la categoría de la Lista Roja de la UICN está en blanco, seleccione una categoría de la Lista Roja que coincida más con su sistema y ingrese más detalles en el campo "Sistema equivalente utilizado" a continuación.',
  equivalentSystemHint:
    'Ingrese detalles sobre el sistema de evaluación equivalente utilizado y enumere las equivalencias utilizadas para CR, EN y VU',
  determinedHint: '',
  ecoBioRegionRestrictedHint:
    'Especifique si la especie está restringida a una ecorregión o a una biorregión como se describe para los subcriterios B3a y B3b en el Estándar KBA. Las especies que carecen de Evaluaciones de la Lista Roja Global de la UICN no se reconocerán como restringidas a una ecorregión o una biorregión; comuníquese con el Secretariado de KBA {mailTo} si tiene alguna consulta sobre la clasificación asignada a esta especie.',
  // eslint-disable-next-line no-dupe-keys
  // ecoRegionNameHint: '',
  evidenceHint:
    '¿Qué evidencia tiene que confirme que la especie está presente en el sitio? Si se basa en la opinión de un experto, ingrese el nombre y el contacto de correo electrónico del experto (asegúrese de que esté dispuesto a compartir los datos de contacto)',
  yearSpeciesDetailsHint: 'Año más reciente de la evidencia de la presencia',
  unitsNumberHint:
    'Ingrese el número mínimo de unidades reproductivas presentes en el sitio. Este es un campo esencial para evaluar los Criterios A1 (excepto A1e), B1, B3b y E. Para más detalles consulte las Directrices de KBA.',
  comprisedHint:
    'Este campo es para ayudar a interpretar el número reportado de UR en el sitio. Diferentes especies tienen diferentes estrategias reproductivas, por lo que 10 UR se expresarán de manera diferente. Algunos ejemplos de definiciones claras de 10 RU son:"Especies que forman parejas: 10 parejas de machos y hembras"."Especies que forman parejas: 10 machos y 10 hembras"."10 nidos activos"."Sistema de apareamiento estilo harén: 1 o más machos y 10 hembras".“Esta especie de musgo está tan compacta que se puede suponer que hay 10 RU en 5 m²”',
  speciesDetailsSourceHint:
    'Proporcione información sobre la fuente de los datos de RU proporcionados: ¿qué evidencia tiene de que el sitio contiene la cantidad mínima de unidades reproductivas que ha ingresado y de que la especie está presente? Incluya cualquier fuente (por ejemplo, referencia a un libro, artículo, informe, URL). ¿Cuál es el año de la estimación de RU? Si se basa en la opinión de un experto, proporcione el nombre y el correo electrónico de contacto del experto (asegúrese de que esté dispuesto a compartir los datos de contacto) y el año en que el experto vio las RU.',
  parameterHint:
    'Revise los datos disponibles en un sitio a nivel global y local para esta especie, y decida qué parámetro de evaluación proporciona la mejor indicación de la proporción del tamaño de la población global a utilizar (puede encontrar más orientación en la Sección 3.1 de las Directrices de KBA). Puede evaluar esta especie utilizando parámetros de evaluación adicionales (si corresponde) y/o en varias temporadas.',
  minGlobal: 'Mín. Global',
  bestGlobal: 'Mejor Global',
  bestGlobalEstimate: 'Estimación global (mejor)',
  maxGlobal: 'Máx. Global',
  newReportTitle: 'Crear nuevo reporte',
  newReportSubTitle: 'Haga clic en el botón del panel de filtro a continuación para continuar',
  filterPannel: 'Panel de filtro',
  enterRegionalMin: 'Ingrese la estimación regional mínima',
  enterRegionalBest: 'Ingrese la mejor estimación regional',
  enterRegionalMax: 'Ingrese la estimación regional máxima',
  regionalMin: 'Regional (mín.)',
  regionalBest: 'Regional (mejor)',
  regionalMax: 'Regional (máx.)',
  regionalEstimate: 'Fuente (estimaciones regionales)',
  euPopulation: 'Estimación de la UE',
  nationalPopulation: 'Estimación nacional',
  euEstimate: 'Fuente (estimación de la UE)',
  nationalEstimate: 'Fuente (estimación nacional)',
  enterSpeciesMinGlobalData: 'Ingrese la estimación global mínima',
  enterSpeciesBestGlobalData: 'Ingrese la mejor estimación global',
  enterSpeciesMaxGlobalData: 'Ingrese la estimación global máxima',
  enterRegionalEstimate: 'Ingrese estimaciones regionales',
  enterEuPopulation: 'Ingrese la estimación de población de la UE',
  enterNationalPopulation: 'Ingrese la estimación de la población nacional',
  enterEuEstimate: 'Ingrese la estimación de la UE',
  enterNationalEstimate: 'Ingrese la estimación nacional',
  enterSpeciesGlobalSourceData: 'Describir la fuente de las estimaciones globales.',
  enterNotesOnSpeciesGlobalData: 'Ingrese cualquier otro detalle relevante para estas estimaciones globales.',
  bestGlobalHint:
    'Si solo tiene un valor global, ingréselo en el campo "Mejor". Si solo tiene un mínimo y un máximo, ingrese el punto medio de estos en el campo "Mejor". Las unidades deben coincidir con las del parámetro de evaluación seleccionado.',
  maxGlobalHint:
    'Ingrese la estimación global máxima (si está disponible) según el parámetro de evaluación seleccionado. Las unidades deben coincidir con las del parámetro de evaluación seleccionado.',
  minGlobalHint:
    'Ingrese la estimación global mínima (si está disponible) según el parámetro de evaluación seleccionado. Las unidades deben coincidir con las del parámetro de evaluación seleccionado.',
  globalDataSourceHint:
    'Si está proporcionando estimaciones globales, ingrese una fuente (incluido un enlace donde esté disponible/relevante) para estas estimaciones (por ejemplo, referencia a un libro, documento, artículo, URL).',
  globalDataNoteHint: 'Ingrese cualquier otro detalle relevante para estas estimaciones globales.',
  regionalMinHint:
    'Ingrese una estimación mínima para la población regional, biogeográfica u otra distinta de esta especie',
  regionalBestHint:
    'Se debe proporcionar una mejor estimación para esta evaluación. Proporcionar la mejor estimación para la población regional, biogeográfica u otra distinta de esta especie',
  regionalMaxHint:
    'Ingrese una estimación máxima para la población regional, biogeográfica u otra distinta de esta especie',
  regionalEstimateHint:
    'Ingrese detalles sobre la fuente de las estimaciones proporcionadas para la población regional, biogeográfica u otra distinta.',
  euPopulationHint: 'Ingrese una estimación del tamaño de la población de esta especie que se encuentra en la UE',
  nationalPopulationHint:
    'Ingrese una estimación del tamaño de la población de esta especie que se encuentra en el país.',
  euEstimateHint: 'Ingrese detalles sobre la fuente de la estimación de la UE proporcionada',
  nationalEstimateHint: 'Ingrese detalles sobre la fuente de la estimación nacional proporcionada',
  minSite: 'Mín. Sitio',
  bestSite: 'Mejor sitio',
  maxSite: 'Máx. Sitio',
  derivation: 'Derivación de la estimación',
  enterSpeciesMinSiteData: 'Ingrese la estimación mínima del sitio',
  enterSpeciesBestSiteData: 'Ingrese la mejor estimación del sitio',
  enterSpeciesMaxSiteData: 'Ingrese la estimación máxima del sitio',
  enterSpeciesSiteSourceData: 'Describa la(s) fuente(s) de las estimaciones del sitio',
  derivationOfEstimate: 'Derivación de la estimación',
  yearOfSitePopulationEstimates: 'Provide year(s) of estimate(s) given (e.g. 2018-2020)',
  enterNotesOnSpeciesSiteData: 'Ingrese cualquier otro detalle relevante para estas estimaciones del sitio.',
  minSiteHint:
    'Ingrese la estimación mínima del sitio (si está disponible) según el parámetro de evaluación seleccionado. Las unidades deben coincidir con las del parámetro de evaluación seleccionado.',
  bestSiteHint:
    'Si solo tiene un valor de sitio, ingréselo en el campo "Mejor". Si solo tiene un mínimo y un máximo, ingrese el punto medio de estos en el campo "Mejor". Las unidades deben coincidir con las del parámetro de evaluación seleccionado.',
  maxSiteHint:
    'Ingrese la estimación máxima del sitio (si está disponible) según el parámetro de evaluación seleccionado. Las unidades deben coincidir con las del parámetro de evaluación seleccionado',
  siteSourceHint:
    'Ingrese una fuente para los datos del sitio que ha ingresado (por ejemplo, referencia a un libro, artículo, informe, URL). Si los datos se toman de una evaluación de la Lista Roja, Ingrese un enlace a la evaluación de la Lista Roja',
  derivationHint: 'Indique cómo se obtuvo la estimación "Mejor (sitio)"',
  siteYearHint: '',
  siteNoteHint:
    'Agregue aquí cualquier nota adicional relacionada con los datos de especies en el sitio y/o para explicar por qué está proponiendo alguna de las selecciones que ha realizado.',
  occupiedHabitat: 'Occupied habitat',
  globallyMostImportant5OccupiedHabitat: 'Provide information about any available sources supporting your selection',
  triggerLabel: '‘Razón(es) por las que la especie no califica',
  triggerEcosystemLabel: 'Motivo(s) por el que el ecosistema ya no cumple los requisitos',
  triggerLabelHint:
    '“Si este elemento desencadenante ya no cumple con los criterios de KBA, indique por qué. Primero debe anular la selección de la casilla de verificación "Califica" y, a continuación, puede seleccionar cualquier motivo que corresponda en el menú desplegable.',
  reasonForSelectionDCriteria: 'Reason for selection D criteria',
  aggregation: 'Aggregations',
  justification: 'Justificación (Criterio D, congregaciones)',
  justificationThatTheSpeciesIsAggregated: 'Ingrese una justificación para sus opciones seleccionadas',
  largestAggregationHint:
    'Este campo es específicamente para especies que se agregan y que podrían activar el Criterio D: describa cómo se agrega la especie  (relevante para D1); proporcionar justificación de que el sitio alberga una proporción significativa de la distribución global de la especie durante períodos de estrés ambiental (relevante para D2); o proporcionar una justificación que demuestre que el sitio es una fuente de reclutamiento (relevante para D3). Si aplica D1b, justifique cómo el sitio se encuentra entre las 10 agregaciones más grandes conocidas para la especie y proporcione detalles sobre los otros 9 sitios.',
  refugium: 'Refugium',
  recruitment: 'Recruitment',
  season: 'Estación',
  specieTriggerPlaceholder: 'If this species no longer qualifies — please select all reason(s)',
  selectMultipleOptions: 'Puede seleccionar varias opciones y hacer clic en Aplicar',
  ecosystemTriggerPlaceholder: 'Improved site information, KBA criteria revision',
  selectSeasonalDistributionAppliedTo: 'Select seasonal distribution applied to',
  aggregationCriteriaHint:
    'Por favor, elija cuidadosamente cuál de las afirmaciones relativas a la naturaleza de la presencia de la especie en este lugar se aplica. Por ejemplo, deberá especificar que la especie forma agregaciones y/o se da con regularidad (para cumplir los criterios pertinentes)',
  occupiedHabitatHint:
    'Is this site part of the globally most important 5% of occupied habitat for this species AND you want to apply subcriterion B3c? If so, select "Yes". If not, use the default setting. See KBA Guidelines section 2.6. Please also submit information with proposal about all sites known which also meet this 5%',
  sourceHabitatHint:
    'Ingrese información sobre cualquier fuente disponible que respalde su selección para la Justificación que hapensé que te ha ingresado para congregaciones (p.ej. referencia a un libro, artículo, informe, URL). Si se basa en la opinión de un experto, Ingrese el nombre y el contacto de correo electrónico del experto (asegúrese de que estén dispuestos a compartir los datos de contacto)',
  reasonHint: ' ',
  seasonHint:
    'Si aplica la estimación a una distribución estacional particular (p. ej., reproductiva o no reproductiva), o a un punto de escala migratoria, seleccione aquí la temporada relevante.',
  evidenceTheSpeciesIsPresentAtTheSite: 'Evidencia de que el activador está presente',
  yearForWitchThereIsEvidence: 'Año más reciente de la evidencia de presencia',
  minNumberOfReproductiveUnitsRuAtSite: 'Número mínimo de unidades reproductivas (UR) en el sitio',
  SpeciesCriteriaTriggered: 'Criterios KBA',
  userId: 'ID de usuario',
  assessmentYear: 'Año de evaluación',
  kbaTriggered: 'Criterios KBA activados',
  largestSystem: 'El sistema más grande en el sitio',
  highEcological: 'Ecorregión con alta integridad ecológica en el sitio',
  sourceReproductiveUnits: 'Fuente de datos de RU',
  whatAre10RusComprisedOf: '¿Qué son 10 RU para este activador?',
  yearPresence: 'Año (presencia)',
  sourceOfRuData: 'Fuente de datos de RU',
  sourceOfReproductiveUnitDataIncludingYear: 'Proporcionar información sobre la fuente de datos de RU',
  assessmentParameterApplied: 'Parámetro de evaluación aplicado',
  parameter: 'Parámetro de evaluación',
  finishEditing: 'Terminar de editar',
  cancelReassessment: '¿Cancelar la reevaluación?',
  globalData: 'Estimaciones globales',
  siteSpeciesData: 'Estimaciones del sitio',
  regNatEstimates: 'Estimaciones Regionales y Nacionales',
  siteEstimate: 'Estimación del sitio (mejor)',
  newParameter: 'Nuevo parámetro',
  aggregations: 'Aggregations',
  pleaseContactTheKBASecretariatForAnyDataConcerns:
    'Complete todos los detalles de la evaluación relacionados con "{specieName}"',
  speciesDetailSubTittle: 'Detalles de la especie',
  speciesDetailSubTittleHint:
    'Seleccione la especie o comuníquese con la Secretaría de KBA si su especie no está en la lista {mailTo}',
  ecosystemSubTitle: 'Datos del ecosistema',
  ecosystemSubTitleHint: 'Complete esta sección si evalúa el sitio según los criterios de ecosistemas A2 o B4',
  speciesAssessmentSubTittle: 'Details about the species at global and site level',
  speciesAssessmentSubTittleHint: 'Please select parameter',
  totalSites: 'Sitios totales',
  mySites: 'Mis sitios {mySitesNumber}',
  totalReports: 'Informes totales',
  organisation: 'Organización',
  levelOne: 'Nivel uno',
  levelTwo: 'Nivel dos',
  levelThree: 'Nivel tres',
  timing: 'Momento',
  selectLevelThreeThreat: 'Seleccione una opción de nivel tres',
  selectLevelTwoThreat: 'Seleccione una opción de nivel dos',
  selectLevelOneThreat: 'Seleccione una opción de nivel uno',
  newThreat: 'Añadir nueva presión',
  levelOneThreatsHint:
    'Seleccione una presión (y los niveles subsiguientes según se solicite) y proporcione detalles sobre su duración',
  levelTwoThreatsHint:
    'Seleccione una presión (y los niveles subsiguientes según se solicite) y proporcione detalles sobre su duración',
  levelThreeThreatsHint: 'Seleccione una presión y proporcione detalles sobre su duración',
  selectTriggerSpeciesSubtitle: 'Seleccione las especies que activan los criterios KBA en este sitio',
  selectTriggerEcosystemSubtitle: 'Seleccione los ecosistemas que activan los criterios KBA en este sitio',
  selectThreatsForThisSite: 'Seleccione las presiones para este sitio',
  threatsHint:
    'Seleccione las presiones en este sitio y seleccione el momento más relevante para cada una. En la sección de seguimiento de la KBA se puede proporcionar más detalles sobre sus impactos en los elementos de biodiversidad de importancia',
  selectThreatLevelTiming: 'Seleccione el momento de esta presione',
  chooseThreats: 'Presiones',
  whatThreatsAreYouAssessingForThisSite: '¿Cuáles son las presiones en este sitio?',
  action: 'Acciones de conservación',
  whatActionsAreAssessingForThisSite: '¿Qué acciones están en curso o son necesarias en este sitio?',
  timingThreatsHint: 'Seleccione el momento de esta presione',
  threatsAndAction: 'Presiones y Acciones',
  removeModal: '¿Seguro que quieres eliminar este comentario de forma permanente?',
  removeModalText:
    '¿Está seguro de que desea eliminar permanentemente {nombre} de la lista? Esta acción no se puede deshacer',
  optional: 'Opcional',
  uploadGisFiles: 'Upload Gis files',
  chooseFile: 'Upload file',
  fileSizeIsTooBig: 'El tamaño del archivo es demasiado grande',
  taxonGroup: 'grupo taxonómico',
  iucnStatus: 'Gato de la Lista Roja.',
  reproductiveUnits: 'RU (mín.)',
  population: '% en el sitio',
  kbaCriteria: 'criterios KBA',
  criteriaKba: 'Criterios cumplidos',
  ibaCriterias: 'Criterios de la IBA',
  calculationsSubTittle: 'Criterios desencadenantes de especies',
  pleaseCompleteThisField: 'Por favor complete este campo',
  removeThreat: 'Quitar presione',
  reviewers: 'Revisores',
  review: 'Revisar',
  commentsLabel: 'Comentarios',
  iucnMember: 'IUCN Member',
  iucnMemberLabel: 'IUCN Member',
  iucnMemberPlaceholder: 'List any IUCN Specialist Groups that you are a member of',
  listToComplete: 'Por favor complete los siguientes campos',
  validation: 'Validación',
  siteDetails: 'Detalles del sitio',
  predefined: 'Predefinido',
  ecosystems: 'ecosistemas',
  ecosystemsAtSite: 'Ecosistemas en el sitio',
  ecosystemRedListCat: 'IUCN Red List of Ecosystems category',
  ecosystemGlobalExtentBest: 'Extensión del sitio del ecosistema (mejor estimación)',
  ecosystemKbaTriggered: 'Ecosystem KBA criteria triggered',
  speciesGlobal: 'Especies Global',
  siteDetailsDescription: 'Más detalles sobre el sitio y su biodiversidad',
  manageabilityDelineation: 'Manejabilidad y Delineación',
  manageabilityDelineationDescription: 'Más detalles sobre la manejabilidad del sitio y la delimitación del límite',
  fieldNamename: 'Nombre del sitio',
  fieldNamesiteNameNational: 'Nombre del sitio nacional',
  fieldNamecountry: 'País',
  fieldNamesiteArea: 'Área del sitio (km2)',
  fieldNamelatitudeOfMidPoint: 'Latitud (grados dec.)',
  fieldNamelongitudeOfMidPoint: 'Longitud (dec. grados)',
  fieldNamelowestAltitude: 'Elevación más baja (m)',
  fieldNamehighestAltitude: 'Altitud más alta',
  minimumDepth: 'Profundidad mínima (m)',
  minimumDepthHint: 'Ingrese la profundidad mínima en metros; los valores de profundidad deben ser positivos',
  minimumDepthPlaceholder: 'Ingrese la profundidad mínima en metros',
  maximumDepth: 'Profundidad máxima (m)',
  maximumDepthHint: 'Ingrese la profundidad máxima en metros; los valores de profundidad deben ser positivos',
  maximumDepthPlaceholder: 'Ingrese la profundidad máxima en metros',
  fieldNameAltitudeOfBathymetryId: '',
  fieldNameEcoSystemsId: 'Sistema más grande',
  fieldNamerationaleForSiteInformation: 'Razón fundamental',
  fieldNamesiteDescription: 'Descripción del lugar',
  fieldNamehowIsTheSiteManaged: 'Sitio administrado',
  fieldNamedeliniationRationale: 'Delineación',
  fieldNameCoverageOfProtectedAreasId: 'Cobertura del sitio',
  '/': 'Página de inicio',
  fieldNameEcologicalIntegrityEcoRegionId: 'Ecorregión',
  fieldNamenumberOfCriterionSitesInEcoRegion: 'Sitio de la ecorregión',
  fieldNameevidenceOfLowHumanImpact: 'Eco integrity - Low Human impact',
  fieldNameevidenceForIntactEcologicalCommunities: 'Eco integrity - ecological communities',
  proposed: 'Propuesto',
  inviteReviewers: 'Invitar revisores',
  supersede: 'Reemplazar',
  commentBox: 'Comentarios {commentNumber}',
  changeStatus: 'Cambiar de estado',
  revertToConfirmed: 'Cambiar a Confirmado',
  changeStatusToConfirmFromSupersede:
    '¿Está seguro de que desea cambiar el estado del sitio {name} de Reemplazado a Confirmado?',
  fieldNamedateOfAssesment: 'Fecha de evaluación',
  unfinishedProposal: 'Se requieren más detalles',
  continueEditing: 'Continúe editando',
  confirm: 'Confirmar',
  incompleteFields: 'Campos incompletos',
  oecmOverlapPlaceholder: 'Seleccione la banda de %',
  oecmDropHint: 'Seleccione la banda de % que mejor refleje la cobertura de los OMEC',
  SiteId: 'Identificación del sitio',
  siteId: 'Identificación del sitio',
  autoSave: 'Autoguardado',
  saving: 'Guardando cambios',
  backToSites: 'Volver a Sitios',
  coProposers: 'Co-proponentes',
  draftSiteMessage: 'Su evaluación está en estado Borrador y no ha sido propuesta',
  proposedSiteMessage: 'Este sitio ahora está Propuesto y está listo para ser revisado por la RFP',
  nominatedSiteMessage: 'Este sitio ahora está Nominado y está listo para ser revisado por el Secretariado de KBA',
  nominateAssessment: '¿Nominar evaluación?',
  nominated: 'Nominado',
  reviewedByRFP: 'Este sitio ahora ha sido revisado y puede ser Nominado por el Proponente',
  feedback: 'Retroalimentación',
  returnFeedback: '¿Devolver retroalimentación?',
  confirmed: 'Confirmado',
  rejectSpecies: 'Rechazar especies',
  confirmSpecies: 'Confirmar especies',
  siteProposal: 'Propuesta del sitio',
  approveSite: 'Aprobar evaluación',
  approveEditOnlySite: 'Aprobar Ediciones',
  reviewEditOnlySite: 'Revisar Ediciones',
  confirmEcosystem: 'Confirmar ecosistema',
  rejectEcosystem: 'Ecosistema rechazado',
  editOnly: 'Solo Edición',
  draftSiteStatusHint: 'El sitio está en borrador',
  proposedSiteStatusHint: 'Se propuso el sitio',
  nominatedSiteStatusHint: 'El sitio fue nominado',
  reviewedSiteStatusHint: 'El sitio fue revisado',
  confirmedSiteStatusHint: 'El sitio fue confirmado',
  supersededSiteStatusHint: 'El sitio fue reemplazado',
  editSiteStatusHint: 'Sitio en Modo de Edición',
  noSpeciesSelected: 'Ninguna especie seleccionada',
  noEcosystemsSelected: 'No hay ecosistemas evaluados',
  reassess: 'Reevaluar',
  ecologicalIntegrityData: 'Datos de integridad ecológica',
  newTriggers: 'Nuevos activadores',
  siteReassessment: 'Evaluación',
  continueReassess: 'Continuar Reevaluación',
  justificationNoChange: 'Detalles adicionales cuando no se realizaron cambios en las estimaciones',
  existingTriggers: 'Activadores existentes',
  nonQualifying: 'No calificable',
  qualifies: 'Califica',
  lastTimeReassessed: 'Fecha de la última evaluación',
  qualificationReasonHint:
    'Proporcione información adicional relacionada con la reevaluación de este elemento de biodiversidad, o escriba N/A.  Si el elemento desencadenante ya no califica, utilice este espacio para proporcionar más detalles si es necesario. Si infiere que su extensión, distribución y/o abundancia no ha cambiado o ha mejorado basándose de alguna otra evidencia, proporcione más detalles y, preferiblemente, incluya una fuente para justificarlo.',
  delisted: 'Eliminado de la lista',
  details: 'Detalles',
  justificationNoChangeEcoSystemPlaceholder:
    'Proporcione una justificación si no está proporcionando estimaciones actualizadas del sitio, p. si está eliminando un ecosistema de la lista o si está infiriendo que la extensión del elemento desencadenante no ha cambiado en función de alguna otra evidencia.',
  siteCriteria: 'Criterios',
  justificationNoChangeSpeciePlaceholder:
    'Proporcione una justificación si no está proporcionando estimaciones actualizadas del sitio, p. si está eliminando un ecosistema de la lista o si está infiriendo que la distribución y la abundancia de la especie no han cambiado en función de alguna otra evidencia.',
  natureOfOccurrence: 'Naturaleza de la ocurrencia',
  localTermsUpdatedOn: 'Actualizado en -',
  localTerms: 'Términos de Uso',
  dateUpdatedOn: '20 February 2022',
  termsPageTitle: 'Términos y condiciones de uso',
  termsPageSubTitle: 'Términos y uso de la base de datos global de Áreas Clave para la Biodiversidad',
  introductionLabel: 'Introducción',
  introductionSubText:
    'La Base de Datos Global de Áreas Clave para la Biodiversidad (WDKBA) ha sido desarrollada por BirdLife Internacional en nombre de la Alianza KBA. Proporciona una herramienta para apoyar a individuos, organizaciones y Grupos Nacionales de Coordinación de KBA para proponer sitios como KBA, documentarlos y delimitarlos, y reevaluarlos para mantener la información actualizada, con el fin de apoyar la conservación de los sitios más importantes para la naturaleza en todo el mundo. Permite la gestión de datos sobre KBA a nivel nacional, regional y global, incluidos los sitios identificados como Áreas Importantes para las Aves y la Biodiversidad y por la Alianza para la Extinción Cero. También facilita el suministro de datos sobre sitios importantes para la biodiversidad a los gobiernos, el sector privado (a través de {linkTo}) y otras partes interesadas, con el fin de promover su protección, conservación y salvaguarda.',
  tableOfContents: 'Tabla de contenidos',
  generalLabel: '1. General',
  generalSubText1:
    'Los Términos y condiciones (en adelante, "Términos") que se describen a continuación se relacionan con los datos ingresados en la Base de Datos Global de Áreas Clave para la Biodiversidad (WDKBA) por parte de los usuarios, incluidos',
  generalBullet1:
    'Todos los datos tabulares, numéricos, textuales o espaciales (y atributos asociados) relacionados con las KBA',
  generalBullet2: 'Datos ingresados para evaluar un nuevo sitio o para reevaluar una KBA existente',
  generalBullet3:
    'Datos relacionados con la importancia de la biodiversidad de un sitio, atributos físicos o sociopolíticos de un sitio, o como parte de una evaluación de monitoreo de un sitio',
  generalBullet4: 'Datos relacionados con evaluaciones preliminares, propuestas, nominadas o confirmadas',
  generalBullet5:
    'Datos ingresados directamente en el portal web de WDKBA, a través de cualquier instalación de carga por lotes o a través de cualquier herramienta asociada (por ejemplo, para enviar o editar datos espaciales o de otro tipo en los límites del sitio)',
  generalBullet6:
    'Datos sobre KBA existentes que se han importado a WDKBA en el momento de su lanzamiento, y cualquier dato ingresado o modificado posteriormente',
  generalSubText2:
    'Los Términos entran en vigencia desde el momento en que usted acepta estos Términos y Condiciones. De vez en cuando, estos Términos pueden ser modificados. En consecuencia, revise los Términos cuando reciba una alerta, ya que cualquier uso que haga después de dichas modificaciones o adiciones se regirá por estos Términos modificados. Estos Términos anularán cualquier otra restricción impuesta a los datos que ingrese en el WDKBA. Al aceptar estos Términos, también acepta seguir los procedimientos descritos en {linkTo2}. Todos los datos descargados de WDKBA están sujetos a {linkTo}, que, entre otras restricciones, no permiten volver a publicar, redistribuir o usar comercialmente.',
  intelectualLabel: '2. Propiedad Intelectual y Titularidad',
  intelectualSubText1:
    'Usted confirma que tiene derecho a enviar cualquier dato ingresado en el WDKBA y que, al hacerlo, no está infringiendo los derechos de ningún tercero. Los usuarios y/o sus instituciones (y los licenciatarios, si los hay) conservan la propiedad intelectual relacionada con los datos que ingresan en la WDKBA y otorgan {linkTo}, como administradores de la WDKBA en nombre de la Alianza de Áreas Clave para la Biodiversidad (KBA), una licencia continua, global e intransferible (con derecho a sublicencia) para usar estos datos (en su formato original, ya sea en su totalidad o en parte, solos o combinados con otros datos), sujeto a la cláusula 5 sobre Sensibilidad datos, sin solicitar autorización previa, con fines de conservación, incluidos',
  intelectualBullet1: 'Volver a publicar en el sitio web de KBA {linkTo}',
  intelectualBullet2:
    'Proporcionar a otros sitios web públicos y plataformas en línea, incluidos los de socios individuales de KBA',
  intelectualBullet3:
    'Proporcionar a terceros para fines de conservación, investigación, educación y otros fines no comerciales',
  intelectualBullet4: 'Uso en aplicaciones de investigación, comunicaciones, promoción y políticas',
  intelectualBullet5:
    "Licencias para uso comercial a través de {linkTo} (IBAT), ya sea haciendo que los datos estén disponibles directamente en IBAT o a través de terceros, y los ingresos generados se utilizan para respaldar la identificación, la gestión de datos o la conservación de KBA. A los efectos de estos Términos, 'uso comercial' significa a) cualquier uso por, en nombre de, o para informar o ayudar a las actividades de una entidad comercial (una entidad que opera 'con fines de lucro') o b) el uso por cualquier persona física o entidad sin fines de lucro con fines de generación de beneficios.",
  intelectualSubText2:
    'Estos fines pueden cumplirse mediante la difusión de estos datos a través de cualquier medio, incluidos sitios web, aplicaciones móviles, servicios web, archivos KML, protocolos de transferencia de archivos, correo electrónico, medios o dispositivos electrónicos, publicaciones y redes sociales, etc. Donde se presentan los datos de KBA en el sitio web de KBA, los usuarios de WDKBA que sean Proponentes o Coproponentes de cada sitio serán reconocidos como tales en las hojas informativas de KBA correspondientes, a fin de reconocer sus contribuciones. Estos reconocimientos se aplicarán a partir de 2022.',
  importantBirdLabel: '3. Datos importantes de Áreas de Aves y Biodiversidad',
  importantBirdSubText:
    'Los usuarios de WDKBA que representan a BirdLife Partners también otorgan a BirdLife Internacional una licencia intransferible para usar datos en sitios activados por aves (Áreas importantes para las aves y la biodiversidad; IBA), en su formato original, ya sea total o parcialmente, solo o combinado, con otros datos, sin solicitar autorización previa, con fines de conservación, incluidos todos los enumerados en la cláusula 3, así como su reenvío en el sitio web de BirdLife Data Zone. Esta licencia se aplica a los datos sobre IBA existentes importados a WDKBA en el momento de su lanzamiento (de conformidad con la cláusula (a) bajo Intercambio de Información y Datos en los Procedimientos operativos de BirdLife), y cualquier dato sobre sitios activados por aves ingresados o modificados posteriormente. Esta licencia seguirá siendo válida incluso si la institución abandona posteriormente o es excluida de los Socios de BirdLife.',
  sensitiveDataLabel: '4. Datos sensibles',
  sensitiveDataSubText:
    'Cualquier evaluación de los elementos de la biodiversidad marcados por los usuarios como Sensible utilizando el campo correspondiente en la base de datos se tratará como se describe en {linkTo1} y no se publicará en {linkTo2}.',
  privacyLabel: '5. Privacidad',
  privacySubText:
    'Como administradores de WDKBA, BirdLife Internacional se compromete a proteger su información personal y privacidad. BirdLife Internacional recopilará y procesará sus datos personales a través del uso de WDKBA de acuerdo con su {linkTo}. Es importante que lea esta política para que sea plenamente consciente de cómo y por qué estamos utilizando sus datos. Esta política de privacidad complementa otros avisos y políticas de privacidad y no pretende anularlos. Tenga en cuenta que al registrarse como usuario en WDKBA, esto permite (a) que otros usuarios lo inviten a participar en la reevaluación de cualquier elemento de biodiversidad en un sitio para el cual usted fue el Proponente, (b) otros usuarios lo inviten como Co-Proponente de un sitio, y (c) Puntos Focales Regionales o el Secretariado de KBA para invitarlo como Revisor de una propuesta de sitio. Estas invitaciones pueden enviarse a través de notificaciones dentro de la propia WDKBA y como correos electrónicos a la dirección que proporcionó cuando se registró.',
  disclaimerLabel: '6. Descargo de responsabilidad sobre fronteras y límites nacionales',
  disclaimerSubText:
    'La designación de entidades geográficas en la WDKBA y las herramientas asociadas no implica la expresión de, ni representa, ninguna opinión por parte de los Socios de KBA con respecto al estado legal de cualquier país, territorio o área, o con respecto a la delimitación de sus fronteras o límites.',
  disclaimerOfWarrantyLabel: '7. Descargo de responsabilidad de la garantía Limitaciones de responsabilidad',
  disclaimerOfWarrantySubText:
    'Ni BirdLife Internacional ni los demás socios de KBA o sus afiliados, ni ninguno de sus respectivos empleados, agentes, proveedores de contenido de terceros o licenciantes garantizan que el acceso y uso de WDKBA estará libre de interrupciones o errores, ni que todos los datos descargados o exportados están libres de virus, gusanos u otros componentes dañinos; no se garantizan los resultados que puedan obtenerse del uso de WDKBA ni la precisión, confiabilidad o contenido de la información extraída de él. Los datos descargados de WDKBA se proporcionan sin garantías de ningún tipo, ya sean expresas o implícitas, incluidas, entre otras, las garantías de título o idoneidad para un propósito particular. En la máxima medida permitida por la ley, en ningún caso BirdLife Internacional u otros socios de KBA serán responsables de daños indirectos, incidentales o consecuentes que surjan del uso o la incapacidad de usar los datos de KBA o WDKBA o que resulten de errores , omisiones, interrupciones, eliminaciones, errores o defectos en los datos de KBA, o demoras en la operación, transmisión o falla en el desempeño de WDKBA, incluso si BirdLife Internacional u otros socios de KBA fueron informados previamente de la posibilidad de tales daños, o para cualquier otro reclamo de usted o cualquier otra persona.',
  indemnificationLabel: '8. Indemnización',
  indemnificationSubText:
    'Usted acepta defender, indemnizar y eximir de responsabilidad a BirdLife Internacional y a otros socios de KBA y a sus afiliados frente a todos los daños, responsabilidades, costos y gastos, incluidos los honorarios de abogados, relacionados con cualquier violación de estos Términos por parte suya o de cualquier usuario autorizado de su cuenta. .',
  terminationLabel: '9. Terminación',
  terminationSubText:
    'BirdLife Internacional, en nombre de la Alianza KBA, puede suspender o finalizar su uso de WDKBA en cualquier momento, con efecto inmediato, con o sin previo aviso, si consideramos que su uso de WDKBA compromete su seguridad o integridad, o es incompatible con los objetivos de {linkTo}. Esto rescinde automáticamente su licencia para usar cualquier dato de KBA descargado de WDKBA.',
  changeManagementLabel: '10. Cambio en el manejo de la WDKBA',
  changeManagementSubText:
    'Si BirdLife Internacional abandona la Alianza KBA y otro socio de KBA asume la gestión de WDKBA, los permisos otorgados aquí se transferirán automáticamente a ese socio de KBA, excepto los de la cláusula 3, que permanecerán en BirdLife Internacional.',
  governingLawLabel: '11. Disputas de leyes aplicables',
  governingLawSubText:
    'Estos Términos y todas las obligaciones no contractuales o de otro tipo que surjan de ellos o en relación con ellos se rigen por la ley inglesa. Cualquier disputa que surja o esté relacionada de alguna manera con estos Términos se remitirá a la jurisdicción de los tribunales ingleses.',
  miscellaneousLabel: '12. Varios',
  miscellaneousSubText:
    'Las disposiciones de estos Términos redundarán en beneficio de BirdLife Internacional y otros socios de KBA y sus proveedores de contenido y licenciantes externos. Ninguna renuncia por cualquiera de las partes del presente de cualquiera de las disposiciones del presente o de cualquier incumplimiento u otro incumplimiento en virtud del presente se considerará como una renuncia a cualquier incumplimiento o incumplimiento anterior o posterior.',
  contactLabel: '13. Información de contacto',
  contactSubText:
    'Si tiene alguna pregunta sobre cualquiera de estos Términos o cómo se pueden aplicar a su uso previsto de WDKBA y los datos de KBA que contiene, comuníquese con {mailTo}',
  minYearPlaceholder: 'Primer año del conjunto de datos',
  earliestYear: 'Año más antiguo (estimación del sitio)',
  minYear: 'Año (min)',
  minYearTooltip:
    'Proporcione el primer año del conjunto de datos para esta especie. Si la evaluación se basa en parámetros basados en el área, indique el año del conjunto de datos que se utiliza para calcular el % de cobertura',
  maxYear: 'Año (máx.)',
  maxYearTooltip:
    'Proporcione el último año del conjunto de datos para esta especie. Si la evaluación se basa en parámetros basados en el área, indique el año del conjunto de datos que se utiliza para calcular el % de cobertura',
  maxYearPlaceholder: 'Último año del conjunto de datos',
  dismiss: 'Despedir',
  cookies: 'Cookies',
  acceptCookies: 'Aceptar cookies',
  cookiesBody:
    'Al hacer clic en el botón Aceptar cookies,\n' +
    'usted comprende y acepta el uso de cookies de acuerdo con nuestro {hyperLink}',
  deleteDraft: '¿Eliminar borrador?',
  deleteEditSiteOnly: 'Borrar Sitio en Modo Edición?',
  siteForDeletingBody:
    '¿Está seguro de que desea\n' +
    'eliminar permanentemente el borrador de la evaluación de {siteName}? Esta acción no se puede deshacer.',
  editSiteForDeletingBody:
    'Está seguro de que desea eliminar las ediciones realizadas en {siteName}? Esta acción no se puede deshacer y los detalles volverán a ser los aprobados durante la última evaluación',
  yesDelete: 'Sí, Eliminar',
  deleteDraftBtn: 'Eliminar borrador',
  cookieSettings: 'Configuración de cookies',
  assess: 'Evaluar',
  reports: 'Mis Informes',
  download: 'Descargar',
  view: 'Vista',
  sensitiveSpecies: 'Aprobación de sitios sensibles',
  sensitiveSpeciesVisibilityStatus: 'Estado de visibilidad',
  sensitiveSpeciesStatusPending: 'Pendiente',
  sensitiveSpeciesStatusApproved: 'Aprobado',
  sensitiveSpeciesStatusRejected: 'Rechazado',
  sensitiveSpeciesRevoke: 'Rechazar',
  sensitiveSpeciesRejectAction: 'Rechazar',
  sensitiveSpeciesAlreadyApproved: 'Este sitio ya ha sido aprobado.',
  sensitiveSpeciesAlreadyRejected: 'Este sitio ya ha sido rechazado.',
  '/reports': 'Informes de mis sitios',
  createReport: 'Crear reporte de mis sitios',
  filters: 'Filtros',
  downloadAll: 'Descargar todo',
  overview: 'Visión general',
  filtersPanel: 'Panel de filtro',
  filtersApplied: 'Filtros aplicados',
  runReport: 'Sacar un reporte',
  siteFilters: 'Filtros del sitio',
  speciesFilters: 'Filtros de especies',
  ecosystemFilters: 'Filtros de ecosistema',
  ecologicalFilters: 'Filtros de Integridad ecológica ',
  otherFilters: 'Otros filtros',
  region: 'Región',
  kbaClassification: 'Clasificación KBA',
  globalKbaCriteria: 'Criterios globales de KBA',
  assessmentDateFilter: 'Año de evaluación',
  selectRegion: 'Seleccione región',
  selectCountry: 'Selecciona tu país',
  selectSystem: 'Seleccionar sistema',
  selectThreat: 'Seleccionar presione',
  selectAssessmentStatus: 'Seleccionar estatus de evaluación',
  selectKbaStatus: 'Seleccione el estatus de KBA',
  kbaStatus: 'Estatus KBA',
  selectKbaClassification: 'Seleccionar clasificación KBA',
  selectGlobalKbaCriteria: 'Seleccionar criterios globales de KBA',
  selectAssessmentDate: 'Seleccionar año de evaluación',
  selectEcosystem: 'Seleccionar ecosistema',
  selectEcosystemRedListCategory: 'Seleccione la categoría de la Lista Roja de Ecosistemas',
  selectEcoregion: 'Seleccionar ecorregión',
  ecoRegion: 'Ecorregión',
  ecoregionBioregionRestricted: 'Restringido a una Ecorregión / Bioregión',
  ecosystemRedListCategory: 'Categoría de la Lista Roja de Ecosistemas',
  species: 'Especies',
  backToReports: 'Volver a Reportes',
  factsheet: 'Ficha informativa',
  id: 'Identificación',
  RedListCategoryCode: 'Categoría de la Lista Roja de la UICN',
  specieName: 'Nombre común',
  IUCNRedListCriteria: 'Criterios de la Lista Roja de la UICN',
  equivalentSystemIfNotRedList: 'Sistema equivalente si no está en la Lista Roja de la UICN',
  EcoBioRegionRestrictedId: 'Eco Bio-Region restricted Id',
  paramId: 'Parameter Id',
  SiteAssessmentParameterTypeId: 'Parámetro de evaluación',
  earliestDataSetYear: 'Earliest year (site estimate)',
  minReproductiveUnits: 'Reproductive units (Min.)',
  ruSource: 'Reproductive units (Source)',
  kbaCriterias: 'Species KBA criteria triggered',
  publishedYear: 'Published year',
  isRedListCategoryCodePrepopulated: 'Is IUCN Red List category prepopulated ?',
  ecoregions: 'Ecoregions',
  bioregions: 'Bioregions',
  SeasonalDistributionId: 'Season Id',
  sourceGlobalData: 'Global estimate (source)',
  latestDataSetYear: 'Latest data set year',
  DerivationOfEstimateId: 'Derivation of site estimate Id',
  sourceOfData: 'Site estimate (source)',
  ruCompromisedOf: 'Reproductive units (what are 10 comprised of?)',
  createdAt: 'Site created at',
  speciesPresenceEvidence: 'Evidence that species is present at site',
  yearPresenceEvidence: 'Most recent yr for evidence of presence',
  regularlyHeld: 'Regularly held',
  regularlyOccurring: 'Regularly occurring',
  regularlyHeldRestricted: 'Regularly held restricted',
  globallyMostImportant: 'Globally most important',
  aggregationPredictability: 'Aggregation predictability',
  aggregationsAsCriteria: 'Aggregations as criteria',
  recruitmentSource: 'Recruitment source',
  treatment: 'Current taxonomic treatment',
  siteAreaCalculated: 'Área del sitio (km2)',
  latitudeOfMidPointCalculated: 'Latitud (grados dec.)',
  longitudeOfMidPointCalculated: 'Longitud (grados dec.)',
  lowestAltitude: '',
  highestAltitude: '',
  thisSpecieAlreadyAddedToSiteAssesment: 'Esta especie ya figura en la evaluación.',
  calculatedProtectedArea: 'Site % area of covered by protected areas/OECMs (calculated)',
  minDepth: '',
  maxDepth: '',
  SiteStatusId: 'Identificación del estatus de KBA',
  SiteDetailsCountryId: 'Site details country id',
  siteCode: 'Código del sitio',
  rationaleForSiteInformation: 'Justificación para la nominación del sitio',
  howIsTheSiteManaged: 'Manejo de sitio',
  deliniationRationale: 'Justificación de la delimitación del sitio',
  CoverageOfProtectedAreasId: 'Site % area of covered by protected areas (user estimated)',
  additionalBiodiversityValues: 'Enumere cualquier especie o ecosistema adicional que se encuentre en el sitio',
  indigenousGroups: 'Site ownership by indigenous peoples',
  indigenousGroupsTemplate: 'Site values (indigenous people or customary use rights)',
  landUseRegimesAtSite: 'Uso de suelo del sitio',
  landUseRegimesAtSiteTemplate: 'Regímenes de uso de suelo en el sitio',
  EcoSystemsId: 'Sistema más grande en la identificación del sitio',
  EcoSystems2LargestId: 'Segundo sistema más grande en el sitio',
  EcoSystems3LargestId: 'Tercer sistema más grande en el sitio',
  EcoSystemsSmallestId: 'El sistema más pequeño en el sitio',
  EcologicalIntegrityEcoRegionId: 'Ecorregión con alta integridad ecológica en el sitio',
  evidenceOfLowHumanImpact: 'Evidencia de bajo impacto humano en el sitio',
  evidenceForIntactEcologicalCommunities: 'Evidencia de comunidades ecológicas intactas en el sitio',
  dateOfAssesment: 'Fecha de evaluación del sitio de integridad ecológica',
  ecoregionEcologicalIntegrity: 'Integridad ecológica de la ecorregión',
  secondLargestSystem: 'Segundo sistema más grande',
  thirdLargestSystem: 'Tercer sistema más grande',
  smallestSystem: 'Sistema más pequeño',
  historyId: 'Identificación de historial',
  importData: 'Datos de importacion',
  browseFile: 'Buscar Archivo',
  orDragACSVFileHere: 'o arrastre un archivo CSV aquí (30 MB de tamaño máximo)',
  downloadCSVTemplates: 'Descargar plantillas CSV',
  validateFile: 'Validando su archivo...',
  fileValidated: 'Archivo validado con éxito',
  important: 'Importante',
  downloadCSVFile: 'Descargar archivo de errores',
  uploadNewFile: 'Subir archivo actualizado',
  importModalErrorBannerText:
    'Descargue el archivo de errores (enlace a continuación) que indica los registros específicos (número de fila) y los campos que deben abordarse. Aquí, hay {count} error/s enumerados. Modifique estos campos en el archivo CSV original y cárguelo nuevamente.',
  validationFailed: 'Validación fallida',
  importingYourData: 'Importando tus datos',
  siteAttributes: 'Atributos del sitio',
  assessmentSpecies: 'Evaluación de especies',
  threatsAndActions: 'Presiones y Acciones',
  dropFileToAttach: 'Soltar archivo para cargar',
  removeFileText:
    '¿Está seguro de que deseas\n' +
    'eliminar permanentemente {title} los archivos subidos? Esta acción no se puede deshacer.',
  'removeFile?': '¿Remover archivo?',
  noResultsToShow: 'No hay resultados para mostrar',
  threatsId: 'Identificación de presiones',
  rejectedTriggers: 'Activadores rechazados',
  approvedTriggers: 'Activadores aprobados',
  permanentTooltipDefaultBody:
    'Tenga en cuenta que al importar el archivo CSV se agregarán los datos del sitio existente',
  permanentTooltipDefaultTitle: 'Importante',
  reportLoadingScreenTitle: 'Informe de construcción',
  runningReport: 'Su informe se está ejecutando, por favor espere...',
  buildingReport: 'Por favor espere, esto puede tomar algún tiempo...',
  permanentTooltipDefaultFooter: 'Entendido',
  congregationSpeciesGroup: 'Grupo de especies',
  congregationSpeciesGroupPlaceholder: 'Seleccionar grupo de congregación',
  minCongregationEstimate: 'Estimación mínima (individuos maduros)',
  minCongregationPlaceholder: 'Ingrese la estimación mínima en individuos maduros',
  bestCongregationEstimate: 'Mejor estimación (individuos maduros)',
  bestCongregationPlaceholder: 'Ingrese la mejor estimación en (individuos maduros)',
  maxCongregationEstimate: 'Estimación máxima (individuos maduros)',
  maxCongregationPlaceholder: 'Ingrese la estimación máxima en individuos maduros',
  detailsCongregationLabel: 'Detalles adicionales',
  detailsCongregationPlaceholder:
    'Proporcione detalles adicionales, como información sobre la fuente de las estimaciones.',
  congregationTitle: 'Congregaciones multi-especies',
  congregationSubTitle: 'Seleccione un grupo de especies y proporcione detalles de la evaluación',
  addNewCongregation: 'Nueva congregación',
  newCongregationTitle: 'Nueva congregación',
  removeCongregations: '¿Quitar la congregación?',
  removeCongregationModalBody:
    '¿Está seguro de que desea eliminar permanentemente a {name} de la lista? Esta acción no se puede\n' + ' deshacer.',
  fileImportError: 'La estructura de archivos o los nombres de campo no deben modificarse',
  congregationTable: 'Congregaciones',
  congregationDataTableSubTitle: 'Sitio desencadenado por criterios de congregación de IBA',
  noCongregationSelected: 'Ninguna congregación seleccionada',
  speciesGroup: 'Grupo de especies',
  estimateBest: 'Estimar (mejor)',
  ibaCriteria: 'Criterios de la IBA',
  biodiversityKnowledgeHolders: 'Poseedores de conocimientos sobre biodiversidad',
  uploadSiteFiles: 'Cargar material de apoyo',
  uploadSiteFilesHint:
    'Cargue cualquier material de respaldo (archivos de Word, PDF, archivos de Excel, datos espaciales, etc.) que respalden esta evaluación (detalles del sitio o del elemento desencadenante). Al nombrar los archivos debe dejar claro con qué parte de la evaluación se relacionan (y/o incluir un archivo “Léame” si hay muchos). El tamaño total de los archivos cargados no debe exceder los 50 MB.',
  biodiversityKnowledgeHoldersPlaceholder:
    'Por favor describa y enumere cualquier consulta a los poseedores de conocimientos sobre biodiversidad relacionadas con esta evaluación',
  biodiversityKnowledgeHoldersHint:
    'Describa y enumere las consultas con los poseedores de conocimiento sobre biodiversidad relacionados con esta evaluación. Estos expertos pueden incluir: científicos internacionales/locales, gobiernos y otros poseedores de conocimientos sobre biodiversidad.',
  previousProposers: 'Proponentes anteriores',
  previousProposersPlaceholder:
    'Por favor, describa sus consultas con cualquier proponente anterior de evaluaciones relacionadas con esta KBA',
  previousProposersHint:
    'Si está modificando los detalles o los límites de una KBA existente, describa las consultas a cualquier proponente de evaluaciones anteriores relacionadas con esta KBA, principalmente documente las discusiones relacionadas con correcciones y resolución de límites. Si no se realizaron cambios, indique "No se realizaron consultas porque esta propuesta no modifica una KBA existente"',
  government: 'Gobierno',
  governmentPlaceholder: 'Describa su consulta con las autoridades gubernamentales pertinentes',
  governmentHint:
    ' Su gobierno local y/o nacional debe estar al tanto de sus evaluaciones de KBA: describa la consulta con las autoridades gubernamentales relevantes, incluidas aquellas asociadas con las consultas anteriores sobre conocimiento de la biodiversidad. Esto puede ser la presentación de las KBA en un taller en el que estuvo presente el gobierno, o reuniones específicas sobre el sitio',
  customaryLegalRightsHolders: 'Titulares de derechos consuetudinarios o legales',
  customaryLegalRightsHoldersPlaceholder:
    'Describa cualquier consulta a los titulares de derechos consuetudinarios o legales',
  customaryLegalRightsHoldersHint: 'Describa cualquier consulta a los titulares de derechos consuetudinarios o legales',
  contributors: 'Colaboradores',
  contributorsPlaceholder: 'Enumerelos nombres de las personas/ su institución, en un formato que pueda publicarse',
  contributorsHint:
    'Enumere los nombres de las personas y, si corresponde, su institución, en un formato que pueda publicarse en el sitio web de KBA; los colaboradores deben ser informados desde el principio que sus contribuciones serán reconocidas de esta manera. No incluya detalles adicionales como datos de contacto, por razones de privacidad de datos',
  searchSitePlaceholder: 'Buscar un sitio por nombre o ID del sitio',
  chooseHabitats: 'Hábitats',
  whatHabitatsAreYouAssessingForThisSite: '¿Qué hábitats están presentes?',
  habitatsHint:
    'En el siguiente menú desplegable, por favor seleccione los hábitats que están presentes en este sitio e indique el porcentaje que ocupa cada hábitat dentro del sitio',
  levelOneHabitatsHint: 'Seleccione el hábitat de alto nivel',
  selectLevelOneHabitat: 'Seleccione entre las opciones de nivel uno',
  selectLevelTwoHabitat: 'Seleccione entre las opciones del nivel dos',
  removeHabitat: 'Eliminar hábitat',
  habitatsPercentage: '% en el sitio',
  habitatsPercentagePlaceholder: 'Ingrese el % del lugar que ocupa el hábitat',
  habitatsPercentageHint: 'Porcentaje de hábitat del sitio',
  newHabitat: 'Nuevo Hábitat',
  map: 'Mapa',
  loadingMap: 'Cargando mapa...',
  siteBoundaryLayerTitle: 'Límite del Sitio',
  allKBAsLayerTitle: 'Todas las KBAs actuales',
  wdpaLayerTitle: 'Sitios de la WDPA',
  wdpaPointLayerTitle: 'Puntos de la WDPA',
  wdpaPolygonLayerTitle: 'Polígonos de la WDPA',
  siteBoundary: 'Límite del Sitio',
  siteBoundaryDescription: 'Descripción corta de la sección Límite del Sitio',
  boundaryNotDefined: 'Límite aún no definido',
  boundaryUnchanged: 'El límite del Sitio no ha cambiado',
  updateBoundaryBySelecting: 'Defina el límite del sitio seleccionando características de las capas:',
  updateBoundaryByDrawing: 'O utilice los siguientes controles para dibujar el límite del sitio en el mapa:',
  updateBoundaryByDrawingOrEditing:
    'O utilice los siguientes controles para dibujar y editar el límite del sitio en el mapa:',
  invalidShapefileError: 'No se ha podido procesar el archivo cargado. Por favor, cargue otro archivo.',
  shapefileWithNoLayersError: 'No se encontraron polígonos en el shapefile cargado. Por favor, cargue otro archivo.',
  fileFormatError: 'Por favor, suba un archivo .zip',
  maxFileSizeError: 'El archivo subido no debe superar los {megabytes}MB. Por favor, cargue un archivo más pequeño.',
  boundaryOverlapsKBALayer:
    'ADVERTENCIA: El límite de su KBA propuesta se superpone con el de otra KBA existente. Aunque puede presentarse, asegúrese de haber realizado las consultas pertinentes para intentar resolver el área(s) que se superponen',
  uploadKBAShpFileHint: 'Suba un shapefile comprimido de menos de 5 MB.',
  addLayer: 'Añadir Capa',
  layerNamePlaceholder: 'Ingrese un nombre para mostrar en la lista de capas',
  layerName: 'Nombre de la Capa',
  firstAddLayer: 'Primero cargue un shapefile o añada una capa...',
  selectFromLayers: 'Seleccionar de las Capas',
  uploading: 'Cargando...',
  mapLayers: 'Capas del Mapa',
  uploadShapefile: 'Cargar Shapefile',
  selectFromLayersInstructions:
    'Seleccione elementos haciendo clic en el mapa o usando la tabla. CTRL + clic/arrastrar le permite seleccionar varias características rápidamente',
  featuresSelected: 'Elementos Seleccionados',
  selectingFeatures: 'Seleccionando Elementos para {boundaryName}',
  useSelectedFeatures: 'Usar Elementos Seleccionados',
  layerSelectLabel: 'Capa para Seleccionar',
  layerSelectPlaceholder: 'Seleccione una capa con los elementos para su límite',
  featureTable: 'Tabla de Elementos',
  showingSelectedFeatures: 'Mostrando funciones seleccionadas',
  showingFeaturesOnScreen: 'Mostrando funciones en pantalla',
  replaceExistingBoundary: 'Reemplazar el límite existente',
  zoomToLayer: 'Ampliar a la capa',
  selectBasemap: 'Seleccionar Mapa Base',
  increaseOpacity: 'Incrementar la opacidad',
  decreaseOpacity: 'Disminuir la opacidad',
  delete: 'Eliminar',
  addFeatureService: 'Enlace a la URL',
  layerUrl: 'URL',
  verifyUrl: 'Verificar URL',
  layerUrlPlaceholder: 'Introducir URL del servicio de funciones',
  selectedLayerOutOfRange: 'La capa seleccionada está actualmente fuera de rango.',
  selectedLayerNotVisible: 'La capa seleccionada no es visible. Activar en lista de capas para ver',
  layerVerified: 'Capa verificada!',
  scaleField: 'Escala: 1 : {scale, number}',
  latitudeAndLongitudeFields: 'Latitud: {latitude}, Longitud: {longitude}',
  zoomToEditAction: 'Ampliar y editar',
  zoomInToEdit: 'Se recomienda acercarse al menos 1 : {scaleCutoff, number} para editar el límite actual.',
  editWithoutZooming: 'Edición sin ampliación',
  siteBoundaryNotEditable: 'Límite del sitio no editable',
  boundaryIsTooComplexAlertMessage:
    'El límite seleccionado no se puede editar en pantalla. Haga clic en el límite para obtener más instrucciones sobre cómo reemplazarlo.',
  boundaryIsTooComplexPopupMessage:
    'El límite seleccionado no se puede editar en pantalla. Si se necesitan revisiones, será necesario crear un nuevo límite localmente y cargarlo. Para ello, elimine primero este límite y, a continuación, siga los pasos habituales para cargar un nuevo límite (corregido).',
  mapView: 'Vista de Mapa',
  tableView: 'Vista de Tabla',
  showTable: 'Mostrar tabla:',
  filterByName: 'Filtrar por nombre:',
  filterByCountry: 'Filtrar por País:',
  enterKBAName: 'Ingrese el nombre nacional de la KBA',
  superseded: 'Sustituido',
  statuses: 'Estatus',
  warningModalHeader: 'Especie no reconocida → Esta especie no está reconocida',
  warningModalExplanation:
    'Esta especie no está reconocida - por favor seleccione una o más de las opciones no calificadas (incluyendo "Revisión taxonómica”) antes de hacer clic en reevaluar, y si desea reevaluar la versión taxonómica actual, entonces añádala como una nueva especie desde la ventana principal de evaluación',
  continue: 'Continuar',
  warningModalHeaderSpecies: 'Esta especie no está reconocida',
  nonQualifyReasonWarning:
    'Por favor, seleccione una o más de las opciones no calificadas a continuación antes de hacer clic en reevaluar, o cancele su reevaluación',
  assessmentParameter: 'Parámetros de evaluación',
  proposalPurposeHint:
    'Por favor, indique el propósito de su propuesta seleccionando una de las opciones a continuación y asegúrese de proporcionar detalles adicionales en el cuadro de texto abierto que sigue. Para las evaluaciones y reevaluaciones, revise los requisitos establecidos en el "Proceso de Propuesta de Áreas Clave para la Biodiversidad: Guía para Proponer, Revisar, Nominar y Confirmar sitios" disponible aquí enlace a Herramientas, y durante las reevaluaciones revise y revise según sea necesario todos los aspectos de la propuesta (detalles del sitio, límites de la ZCB, etc.). Si selecciona una de las opciones de solo edición, no está realizando una evaluación o reevaluación, sino que solo está enviando correcciones de los límites o ediciones menores que no requieren una reevaluación, como corregir errores ortográficos. Tendrá que hacer clic en proponer una vez que se realicen estos cambios. Estas ediciones serán revisadas por el RFP y la Secretaría ZCB, y si se aprueban, la fecha de la evaluación no se actualizará.',
  proposalDetailsHint: 'Proporcione cualquier otro detalle sobre la naturaleza de su propuesta',
  proposalPurposeLabel: 'Indique el propósito de su propuesta',
  proposalDetailsLabel: 'Proporcione cualquier otro detalle sobre la naturaleza de su propuesta',
  proposalDetailsPlaceholder: 'Proporcione más detalles sobre su propuesta',
  proposalPurposePlaceholder: 'Seleccione el propósito de su propuesta',
  editNow: 'Solo Edición',
  editOnlyStatus: 'Solo Edición',
  submitEdits: 'Enviar Ediciones',
  deleteEdits: 'Eliminar Ediciones',
  editOnlyMessage:
    'Al hacer clic en "Continuar", su evaluación estará en modo "Sólo edición". Esta opción permite editar algunos campos de las pestañas "Detalles del sitio" y "Acerca de", y no constituye una reevaluación. En la pestaña "Acerca de", indique su nombre y la lista de campos que está editando (o resuma los cambios realizados si se trata de muchos campos). Tenga en cuenta que ningún otro usuario podrá editar o reevaluar el sitio hasta que usted complete o cancele sus ediciones. Puede invitar a colaboradores a contribuir utilizando la opción "Invitar a co-proponentes". Si decide no seguir adelante, puede descartar sus ediciones en cualquier momento. Una vez finalizadas sus ediciones, sométalas a revisión para completar el proceso.',
  reassessmentMessage:
    'Al hacer clic en "Evaluar biodiversidad" está iniciando una reevaluación y este sitio no podrá ser evaluado por nadie más hasta que usted haya completado el proceso (hasta alcanzar el estado de confirmado). Puede invitar a otras personas a participar en la evaluación a través de la opción "Invitar a co-proponentes". Si decide que no desea completar la reevaluación, puede eliminar su proyecto de evaluación en cualquier momento.',
  submit: 'Enviar',
  approveEdits: 'Aprobar ediciones',
  contributorsAssessmentHint:'Documente a quienes contribuyeron a esta evaluación, incluyendo sus nombres y, si corresponde, su institución. Asegúrese de incluir a estos colaboradores en la lista general de colaboradores del sitio (Detalles del sitio). Por motivos de privacidad de datos, no incluya detalles adicionales como datos de contacto.',

  '/sites/map': 'Sites management map',
  apiKeysTitle: 'API Keys',
  browseShapeFile: 'Browse Shapefile',
  bulkImportData: 'Bulk Import Data (Optional)',
  bulkImportShapeFile: 'Bulk Import Shapefile (Optional)',
  cancelEcosystemReassessment: 'Cancel ecosystem reassessment?',
  confirmBulkReassessment: 'I confirm this Excel includes bulk reassessments',
  congregationTriggerPlaceholder: 'If this congregation no longer qualifies — please select all reason(s',
  contributors_assessment: 'Contributors to this assessment',
  contributorsAssessmentPlaceholder: 'Enter contributors to this assessment',
  criterionCTriggerPlaceholder: 'If this ecological integrity no longer qualifies — please select all reason(s',
  criterionETriggerPlaceholder: 'If this irreplaceability no longer qualifies — please select all reason(s',
  downloadTemplate: 'Download Template',
  filesUploadedSuccessfully: 'Files uploaded successfully',
  generateApiKey: 'Generate API Key',
  ibaStatus: 'IBA status',
  ignoreExistingHabitats: 'Ignore existing habitats',
  justificationNoChangeCongregationPlaceholder: 'Please provide justification if you are not providing updated assessment details -  e.g. if you are delisting a congregation or if you are inferring that the trigger element extent is unchanged based on some other evidence',
  justificationNoChangeCriterionCPlaceholder: 'Please provide justification if you are not providing updated assessment details -  e.g. if you are delisting an criterion C or if you are inferring that the trigger element extent is unchanged based on some other evidence',
  justificationNoChangeCriterionEPlaceholder: 'Please provide justification if you are not providing updated assessment details -  e.g. if you are delisting an criterion E or if you are inferring that the trigger element extent is unchanged based on some other evidence',
  kbaAssessment: 'KBA assessment',
  lastProposer: 'Last proposer',
  orDragAZipFileHere: 'or drag a ZIP file here (30MB max. size)',
  orDragAxlsxFileHere: 'or drag a XLSX file here (30MB max. size)',
  returnDiscardEcosystemChangesText: 'Are you sure you want to discard the reassessment for {ecosystemName}? All of your changes will be discarded and the former assessment of this ecosystem will be reinstated.',
  seasonId: 'Season ID',
  seasonPlaceholder: 'Select a season',
  seasonToolTip: 'Select season',
  selectLevelThreeHabitat: 'Select from level three options',
  speciesUploader: 'Upload supporting documentation species assessments',
  speciesUploaderHint: 'Please upload any documentation that supports species included in the identification of this KBA (word files, PDFs, excel files, spatial data etc.). Include the site code, year of assessment, and mention of the species in the names of any files uploaded. Note the total size of your files uploaded should not exceed 50MB. If you have many spatial files that you wish to provide please contact the KBA Secretariat. Once the KBA is confirmed this documentation will not be visible to WDKBA users.',
  triggerCongregationLabel: 'Reason(s) why congregation no longer qualifies',
  uploadSupportingDocumentation: 'Upload supporting documentation',
  uploadSupportingDocumentationHint: 'Please upload any documentation that supports this KBA proposal (word files, PDFs, excel files, spatial data etc.). Include the site code, year of assessment, and mention of the species in the names of any files uploaded. Note the total size of your files uploaded should not exceed 50MB.',
  yearMax: 'Year (max)',
  yearMaxPlaceholder: 'Last year of the dataset',
  yearMaxToolTip: 'Enter latest year of the data',
  yearMin: 'Year (min)',
  yearMinPlaceholder: 'Earliest year of the dataset',
  yearMinToolTip: 'Enter earliest year of the data',
  // sensitiveSpeciesWarningTitle: 'Nota:',
  // sensitiveSpeciesWarningBody: 'Por favor, asegúrese de explicar claramente qué especies o grupos taxonómicos planea reevaluar. Es posible que algunas de las especies que califican en este sitio hayan sido marcadas como sensibles y no sean visibles de inmediato para usted como proponente individual. Si su(s) grupo(s) taxonómico(s) de interés incluye(n) alguna de estas especies sensibles, la Secretaría KBA se pondrá en contacto con usted al respecto.',
  sensitiveSpeciesSubmitted: 'Su solicitud de reevaluar este sitio ha sido recibida y se procesará en breve. Gracias por su paciencia.',
  sensitiveSpeciesAlreadySubmitted: 'Esta solicitud ya ha sido enviada.',
  sensitiveSpeciesSubmitError: 'No se pudo enviar los datos de especies sensibles. Por favor, inténtelo de nuevo.',
  submitting: 'Enviando...',
  failedToLoadSensitiveSites: 'No se pudieron cargar los sitios sensibles. Por favor, inténtelo de nuevo.',
  sensitiveSiteApproved: 'El sitio de especies sensibles ha sido aprobado correctamente.',
  failedToApproveSensitiveSite: 'No se pudo aprobar este sitio. Por favor, inténtelo de nuevo.',
  sensitiveSiteRejected: 'El sitio de especies sensibles ha sido rechazado.',
  failedToRejectSensitiveSite: 'No se pudo rechazar este sitio. Por favor, inténtelo de nuevo.',
  okay: 'De acuerdo',
  // yearSpeciesDetailsHint: 'Most recent year for evidence of presence',
  sensitiveSpeciesWarningTitle: 'Advertencia de Especies Sensibles',
  sensitiveSpeciesWarningBody:
    'Este sitio contiene especies sensibles. Tenga en cuenta que los datos de especies sensibles no se publicarán públicamente.',
  // contributorsAssessmentHint:
  //   'Documente a quienes contribuyeron a esta evaluación, incluyendo sus nombres y, si corresponde, su institución. Asegúrese de incluir a estos colaboradores en la lista general de colaboradores del sitio (Detalles del sitio). Por motivos de privacidad de datos, no incluya detalles adicionales como datos de contacto.',
  //monitoring
  state: 'Estado',
  pressure: 'Presión',
  response: 'Respuesta',
  guidanceandtools: 'Guía y herramientas',
  selectStatePressureResponse: 'Seleccione Estado, Presión y/o Respuesta',
  monitoringEvaluation: 'Evaluación de monitoreo',
  monitoringSites: 'Evaluación de monitoreo',
  addMonitoringEvaluation: 'Agregar Evaluación de Monitoreo',
  editMonitoringEvaluation: 'Editar Evaluación de Monitoreo',
  editMonitoringRevaluation: 'Editar la reevaluación del monitoreo',
  reEvaluateMonitoring: 'Reevaluar la Monitorización',
  viewMonitoringEvaluation: 'Ver Evaluación de Monitoreo',
  monitoringAboutPageTitle: 'Acerca de la evaluación de monitoreo',
  aboutMonitoringEvaluation: 'Acerca de la evaluación de monitoreo',
  monitoringSubHeading: '¿Cuál será este subtítulo?',
  evaluationTypeQuestion: '¿Cuál de Estado, Presión y Respuesta evaluará?',
  selectEvaluationType: 'Seleccione el tipo de evaluación',
  stateDataQuality: 'Calidad de los datos de estado:',
  stateDataQualityInfo: 'Proporcione una indicación de la calidad de los datos de estado',
  pressureDataQuality: 'Calidad de los datos de presión:',
  pressureDataQualityInfo: 'Proporcione una indicación de la calidad de los datos de presión',
  responseDataQuality: 'Calidad de los datos de respuesta:',
  responseDataQualityInfo: 'Proporcione una indicación de la calidad de los datos de respuesta',
  additionalSiteFeedback: 'Comentarios adicionales del sitio',
  monitoringObjective: 'Describa el objetivo de este monitoreo',
  monitoringReferences: 'Proporcione cualquier referencia u otras fuentes',
  monitoringMethods: 'Describa los métodos, herramientas o equipos utilizados en este monitoreo',
  uploadSupportingMaterial: 'Subir material de apoyo',
  otherRelevantDetails: 'Cualquier otro detalle relevante',
  selectAllThatApply: 'Seleccione todo lo que corresponda',
  stateDataInfo:
    'Seleccione la opción que mejor refleje la calidad de los datos o conocimientos que respaldan su evaluación del estado.',
  pressureDataInfo:
    'Seleccione la opción que mejor refleje la calidad de los datos o conocimientos que respaldan su evaluación de la presión.',
  responseDataInfo:
    'Seleccione la opción que mejor refleje la calidad de los datos o conocimientos que respaldan su evaluación de la respuesta.',
  additionalFeedbackinfo:
    'Proporcione cualquier contexto o información adicional relevante para esta evaluación de monitoreo.',
  monitoringReferencesinfo:
    'Proporcione cualquier contexto o información adicional relevante para esta evaluación de monitoreo.',
  otherRelevantDetailsInfo:
    'Proporcione cualquier contexto o información adicional relevante para esta evaluación de monitoreo.',
  monitoringAboutPageSubTitle: '¿Cuál será este subtítulo?',
  monitoringAboutProposalHint:
    'Indique los criterios que está aplicando en el sitio, incluso si el sitio no cumplió con todos ellos.',
  evaluationTypeLabel: '¿Cuál de Estado, Presión y Respuesta evaluará?',
  stateDataQualityPlaceholder: 'Indique la calidad de sus datos de estado',
  pressureDataQualityPlaceholder: 'Indique la calidad de sus datos de presión',
  responseDataQualityPlaceholder: 'Indique la calidad de sus datos de respuesta',
  stateDataQualityLabel: 'Calidad de los datos de estado:',
  pressureDataQualityLabel: 'Calidad de los datos de presión:',
  responseDataQualityLabel: 'Calidad de los datos de respuesta:',
  monitoringEvaluationDateLabel: 'Fecha de la evaluación de monitoreo',
  monitoringEvaluationDatePlaceholder: 'Seleccione la fecha de la evaluación de monitoreo',
  stateDataQualityHint:
    'Seleccione la opción que mejor refleje la calidad de los datos/conocimientos que informan su evaluación del estado.',
  pressureDataQualityHint:
    'Seleccione la opción que mejor refleje la calidad de los datos/conocimientos que informan su evaluación de la presión.',
  responseDataQualityHint:
    'Seleccione la opción que mejor refleje la calidad de los datos/conocimientos que informan su evaluación de la respuesta.',
  additionalSiteFeedbackPlaceholder: 'Por favor, proporcione cualquier comentario adicional.',
  additionalSiteFeedbackHint:
    'Agregue cualquier otro comentario que refleje qué tan bien comprende lo que ocurre en el sitio en general: los elementos desencadenantes, las presiones y la efectividad de las acciones.',
  provideAnyReferencesSources: 'Proporcione referencias u otras fuentes',
  provideAnyReferencesSourcesPlaceholder:
    'Referencias y fuentes que se utilizaron para informar esta evaluación de monitoreo.',
  provideAnyReferencesSourcesHint:
    'Proporcione detalles o referencias que se utilizaron para informar esta evaluación de monitoreo',
  uploadRelevantFiles: 'Cargar archivos relevantes',
  uploadRelevantFilesHint:
    'Cargue cualquier material de apoyo (archivos Word, PDF, Excel, datos espaciales, etc.) que respalde esta evaluación de monitoreo. Debe quedar claro al nombrar los archivos a qué parte de la evaluación se refieren (y/o incluir un archivo readme si hay muchos). El tamaño total de los archivos cargados no debe superar los 50 MB.',
  anyOtherDetailsRelevance: 'Cualquier otro detalle de relevancia',
  anyOtherDetailsRelevancePlaceholder:
    'Una descripción general de cómo abordó la evaluación de monitoreo y/o cualquier otro comentario que considere útil.',
  statePressureQualityOptions:
    'Seleccione cuál de Estado, Presión y Respuesta evaluará (intente evaluar todos); su selección afectará el nivel de detalle disponible para completar en las pestañas siguientes]',

  generalMonitoringFeedback:
    'Una descripción general de cómo abordó la evaluación del monitoreo y/o cualquier otro comentario que considere útil',
  // Response
  responseTitle: 'Evaluación de la respuesta',
  protectedAreas:
    "La banda que refleja el porcentaje del sitio cubierto por Áreas Protegidas (AP) ha sido preseleccionada con base en el valor generado a partir de una superposición entre la capa de KBA y la de AP en la WDPA. Si considera que el porcentaje actual cubierto por áreas protegidas no se refleja con precisión, realice una evaluación paralela de 'Solo edición' para cambiar el valor de porcentaje de cobertura de AP proporcionado por el usuario en la pestaña de Detalles del sitio.",
  conservationMeasures:
    "La banda que refleja el porcentaje del sitio cubierto por Otras Medidas de Conservación Efectivas Basadas en Áreas (OMEC) ha sido preseleccionada con base en el valor generado a partir de una superposición entre la capa de KBA y la de OMEC en la WDPA. Si considera que el porcentaje actual cubierto por OMEC no se refleja con precisión, realice una evaluación paralela de 'Solo edición' para cambiar el valor de porcentaje de cobertura de OMEC proporcionado por el usuario en la pestaña de Detalles del sitio.",
  // managementPlanning:
  //   'Seleccione la opción que mejor refleje el alcance de la planificación de la gestión en este sitio',
  managementPlanningTitle: 'Planificación de la Gestión',
  responseEvaluationTitle: 'Evaluación de la respuesta (Medidas de conservación del sitio)',
  provideConservationDetails: 'Proporcione detalles sobre las medidas de conservación en el sitio',
  conservationActionTest: 'Seleccione la opción que mejor refleje las acciones de conservación en este sitio',
  coverageByProtectedAreas: 'Cobertura por Áreas Protegidas',
  coverageByOecms: 'Cobertura por Otras Medidas de Conservación Efectivas Basadas en Áreas (OMEC)',
  conservationActionsUnderwayAndNeeded: 'Acciones de conservación en curso y necesarias',
  conservationActionsUnderwayAndNeededInfo:
    "Enumere las acciones de conservación más necesarias y relevantes para los elementos desencadenantes de la biodiversidad en este sitio. Indique también cuáles están en curso. Si se ha proporcionado información sobre acciones de conservación como parte de evaluaciones de monitoreo o evaluaciones y reevaluaciones anteriores, estas se incluirán en la lista; revise las acciones de conservación previamente documentadas que sean relevantes para los elementos desencadenantes de criterios para este sitio (necesarias y/o en curso). Actualice esta lista: 1) seleccionando 'necesarias' y/o 'en curso', 2) añadiendo otras acciones que no se documentaron previamente, o 3) eliminando cualquiera que ya no sea relevante para los elementos desencadenantes.",
  provideMonitoringDetails:
    'Responda las siguientes preguntas relacionadas con la planificación de la gestión y las acciones de conservación que se están llevando a cabo en el sitio, y proporcione detalles de las medidas de conservación en curso y/o necesarias en el sitio.',
  selectManagementPlanning: 'Indique el alcance de la planeación del manejo en el sitio',
  // managementPlanningTitle: 'Planeación del manejo',
  selectConservationAction: 'Indique el alcance de las acciones de conservación en el sitio',
  conservationActionsTitle: 'Acciones de Conservación',
  conservationActionsUnderway: 'Acciones de conservación en curso',
  conservationActionsNeeded: 'Acciones de conservación necesarias en el sitio',
  bulkAction: 'Acción masiva',
  selectTiming: 'Seleccionar momento',
  deleteConservationActionSuccess: 'Acción de conservación eliminada con éxito',
  deleteConservationActionError: 'Error al eliminar la acción de conservación. Por favor, inténtalo de nuevo',
  actionsLevel1: 'Acciones - Nivel 1',
  actionsLevel2: 'Acciones - Nivel 2',
  actionsLevel3: 'Acciones - Nivel 3',
  selectAction: 'Seleccionar acción',
  monitoringForDeletingDraft:
    '¿Está seguro de que desea eliminar permanentemente\n' + 'este borrador? Esta acción no se puede deshacer.',
  editmonitoringForDeletingBody:
    '¿Está seguro de que desea eliminar permanentemente\n' +
    'este monitoreo de la lista? Esta acción no se puede deshacer.',
  assessments: 'Evaluaciones',
  // biodiversityEvaluations: 'Evaluaciones de biodiversidad',
  allBiodiversityEvaluations: 'Todas las evaluaciones {assessmentsNumber}',
  noBiodiversityEvaluations: 'Todas las evaluaciones (0)',
  furtherDetails: 'Proporcione más detalles que expliquen sus selecciones de acciones de conservación anteriores',
  // furtherDetailsPlaceholder: 'Por favor, proporcione más detalles',

  // state
  stateTitle: "Evaluación del estado",
toolTipstateTitle:
  "Las especies y los ecosistemas de importancia en este sitio se enumeran a continuación y pueden seleccionarse para su evaluación. Puede seleccionar todos los desencadenantes o marcar una selección de elementos desencadenantes. Estos desencadenantes constituirán la base de su evaluación del estado y se deberán completar los detalles para todos los que seleccione. Puede ajustar esta selección a medida que avanza.",
stateSubHeading:
  "Seleccione los elementos de biodiversidad que desea monitorear para el estado",
selectBiodiversity: "Seleccionar biodiversidad",
selectBiodiversityInfo:
  "Seleccione los elementos de biodiversidad que constituirán la base de su evaluación del estado",
toolTipselectBiodiversity:
  "Seleccione las especies desencadenantes y/o los tipos de ecosistemas de esta KBA que reflejen el estado del sitio y que monitoreará (o seleccione «Todos»)",
createStateEvaluation: "Crear evaluación del estado",
selectState: "Seleccionar todo",
stateShowing: "Mostrando",
add: "Agregar",
stateBiodiversityTitle:
  "Elementos de biodiversidad a evaluar para el estado",
stateBiodiversitysub:
  "Seleccione los elementos de biodiversidad para agregar más detalles de evaluación",
triggers: "Desencadenantes",
triggersSub:
  "Seleccione los desencadenantes para agregar los detalles de la evaluación del estado",
addMoreTrigger:
  "Agregar más desencadenantes a la evaluación del estado",
benchmarkDetails: "Detalles de referencia",
benchmarksubhead:
  "Detalles de referencia para el elemento desencadenante seleccionado",
benchmarktooltip:
  "Indique la naturaleza de la evaluación del estado para este desencadenante seleccionando una de las opciones a continuación. Si puede proporcionar una estimación actual para este elemento desencadenante, seleccione la primera opción. Si no cuenta con datos que respalden una estimación actualizada, puede indicar una categoría de cambio.",
biodiversitytriggerElement:
  "Elemento desencadenante de biodiversidad",
bioTaxonomicGroup: "Grupo taxonómico",
bioNumberEvaluation:
  "Número de evaluaciones de monitoreo",
bioEvaluation:
  "Seleccionar número de evaluaciones de monitoreo",
bioBaselineYear: "Año de referencia",
bioMonitoringPerameter:
  "Parámetro de monitoreo",
bioBenchmarkValue:
  "Valor de referencia",
bioMonitoringPerameterToolTip:
  "Si no está utilizando el parámetro de evaluación original del elemento desencadenante, defina el parámetro que ha elegido aplicar (por ejemplo, número de nidos, madrigueras, polluelos nacidos, etc.). Idealmente, el mismo parámetro debería utilizarse en evaluaciones posteriores.",
bioBenchmarkValueToolTip:
  "Si no está utilizando la estimación y el parámetro de evaluación usados cuando este elemento de biodiversidad fue identificado por primera vez como desencadenante para este sitio, proporcione aquí una estimación actualizada y defina el parámetro utilizado a continuación. Tenga en cuenta que esta estimación debe reflejar la abundancia (especies) / extensión (ecosistemas) para el año de referencia.",
bioSubTitle:
  "Detalles que informan sobre el estado de este elemento desencadenante en el sitio",
natureOfTheStateEvaluation:
  "Definir la naturaleza de la evaluación del estado para este desencadenante",
toolTipbenchmarkfield:
  "Indique la naturaleza de la evaluación del estado para este desencadenante seleccionando una de las opciones a continuación. Puede 1) proporcionar una estimación actual para este elemento desencadenante (primera opción) o 2) indicar la categoría de cambio si no puede proporcionar una estimación actualizada. Idealmente, esta categoría de cambio estará informada y respaldada por otros factores, como por ejemplo cambios en la extensión del hábitat disponible (cuando se sabe que el desencadenante está influenciado por la disponibilidad de hábitat adecuado) o una evaluación basada en una muestra representativa de datos del sitio. Para los desencadenantes de ecosistemas, proporcione también una evaluación de la condición basada en las categorías disponibles en el menú desplegable. Las siguientes preguntas se relacionarán específicamente con las opciones seleccionadas.",
changeGenuine: "¿El cambio es genuino?",
toolTip2:
  "Desmarque si la evaluación del estado proporcionada para este desencadenante no refleja un cambio real en su población / extensión / condición, sino que es el resultado de otro factor, por ejemplo, una mejora en la precisión de la estimación debido a mejoras en las técnicas de muestreo y análisis. En tales circunstancias, y cuando proporcione una estimación actualizada, si también puede ajustar la referencia en consecuencia, el cambio genuino es apropiado. Puede proporcionar más detalles sobre las evaluaciones que no reflejan un cambio genuino en «Cualquier otro detalle relevante» en la pestaña «Acerca de».",
updateEstimate: "Proporcionar una estimación actualizada",
benchmarkValuefield3:
  "Proporcionar una estimación actualizada del valor de referencia",
tooltip3:
  "Proporcionar una estimación actualizada basada en la referencia y el parámetro indicados anteriormente",
benchmarkfield4:
  "Proporcionar más detalles para justificar su selección",
stateCategoryBestDescribes:
  "Indicar la categoría de estado que mejor describe el porcentaje restante",
toolTipbenchmarkfield5:
  "Indique a continuación la categoría de estado que mejor describe el porcentaje (de la población de la especie o de la extensión del ecosistema) restante en relación con la referencia",
stateCategoryEcosystem:
  "Indicar la categoría de estado que mejor describe la condición de este desencadenante de ecosistema en relación con la referencia",
toolTipbenchmarkfield6:
  "Esta pregunta se refiere específicamente a los ecosistemas y a cómo ha cambiado su condición en relación con la referencia, y el resultado puede diferir de la extensión indicada anteriormente. Proporcione a continuación más detalles relevantes sobre cómo se midió y comparó la condición del ecosistema.",
categoryInferring:
  "¿Cómo se eligió esta categoría que infiere el estado?",
toolTip7:
  "Proporcione más detalles sobre la evidencia que influyó en su(s) selección(es) de categoría(s) anterior(es), por ejemplo, otras observaciones indirectas que pueden haberse basado en un monitoreo sistemático en la región / áreas circundantes o en otros lugares, o información sobre el cambio en una o más amenazas conocidas que afectan al desencadenante en la KBA.",
furtherDetailsJustify:
  "Proporcionar más detalles para justificar su selección",
toolTip8:
  "Proporcione cualquier otro detalle relevante con respecto a su(s) selección(es) de categoría(s) anterior(es); por ejemplo, para la condición del ecosistema, explique cómo se midió y comparó la condición",
benchmarkCondition: "Condición de referencia",
modalTitle: "Evaluación del estado de la especie",
backToSelection: 'Volver a la selección',
// species: 'Especies',
ecosystem: 'Ecosistema',
creating: 'Creando...',


  // assessments: 'Evaluaciones',
  biodiversityEvaluations: 'Evaluaciones de biodiversidad',
  // allBiodiversityEvaluations: 'Todas las evaluaciones {assessmentsNumber}',
  // noBiodiversityEvaluations: 'Todas las evaluaciones (0)',
  // furtherDetails: 'Proporcione más detalles que expliquen sus selecciones de acciones de conservación anteriores',
  furtherDetailsPlaceholder: 'Por favor, proporcione más detalles',
  noReassessmentHistory: 'No hay historial de reevaluación',
  confirmationIncomplete:
    'Esta evaluación incluye solamente {sections}. ¿Está seguro de que desea enviar esta evaluación sin haber completado las tres categorías (estado, presión y respuesta)?',
  confirmationFinal: '¿Está seguro de que desea enviar esta evaluación? Una vez enviada, ya no podrá ser editada.',
  validationMonitoring:
    'Faltan algunos detalles en su evaluación de seguimiento. Revise los detalles proporcionados y complete la información faltante (indicada mediante un recuadro rojo y un texto de advertencia rojo).',
  pressureTriggerValidation: 'Por favor, complete al menos un desencadenante',
  stateEvaluationValidation: 'Por favor, complete al menos una evaluación',

  //pressure tab
  pressureTitle: "Evaluación de presión",
  pressureSubHeading: "Listar las presiones que afectan la biodiversidad en este sitio",
  selectPressures: "Seleccionar presiones",
  selectPressuresInfo: "Seleccionar las presiones que formarán la base de su evaluación de presión",
  reviewPressureSelector: "Revisar presiones y sus plazos",
  reviewPressureSubtitle: "Seleccionar los desencadenantes para agregar detalles de evaluación de estado",
  pressureInfoTooltip: "Proporcione detalles de monitoreo sobre el sitio",
  threatTitle:"Impactos de amenazas en detalles de elementos desencadenantes",
  threatSubTitle:"Cómo se ven afectados los elementos desencadenantes por las amenazas",
  threaInfoToolTip:"Indique para cada amenaza los elementos desencadenantes que se ven afectados, y donde sea posible identifique el alcance y gravedad de la amenaza sobre cada impacto en los elementos desencadenantes.",
  selectTriggerSpceies:"Seleccionar especies desencadenantes",
  addDetailsEffect:"Agregar detalles del efecto",
  selected:'seleccionado',
  // expand:"Expandir",
  close:"Cerrar",
  scopeOfThreat:"Alcance de la amenaza",
  severityOfThreat:"Gravedad de la amenaza",
  threatTiming:"Cronología",
  // selectTriggerSpeciesSubtitle:"Seleccionar los elementos desencadenantes a incluir y luego hacer clic en 'Agregar a la evaluación'",
  selectTriggerSpeciesInfo:"Indique para cada amenaza los elementos desencadenantes que se ven afectados y, cuando sea posible, identifique el alcance y la gravedad de la amenaza en el impacto de cada elemento desencadenante.",
  apply:"Aplicar",
  displaying:"Mostrando",
  addDetails:"Agregar más detalles",
  nextTriggersAffected:"Siguiente > desencadenadores afectados",
  selectedPressureTitle:"Presión seleccionada",
  pressureTriggerTitle:"Seleccione especies desencadenantes y/o ecosistemas que se vean afectados",
  pressureTriggerSubTitle:"Una vez agregados a su evaluación, puede agregar más detalles",
  selectAll:"Seleccionar todo",
  addTriggersToEvaluationBtn:"Añadir a la evaluación",
  addEcosystemTriggersToEvaluationBtn:"Añadir a la evaluación",
  // noRecordsFound:"No se encontraron registros",
  selectTriggerEcosystemInfo:"Indique para cada amenaza los elementos desencadenantes que se ven afectados y, cuando sea posible, identifique el alcance y la gravedad de la amenaza en el impacto de cada elemento desencadenante.",
  threatImpactTriggerTitle:"Impactos de amenazas en detalles de elementos desencadenantes",
  threatImpactTriggerSubTitle:"Cómo se ven afectados los elementos desencadenantes por las amenazas",
  addMoreTriggerBtnText: "Agregar {name}",
  threatTriggerSpecieSubTitle:"Seleccionar las opciones que mejor reflejen el alcance y gravedad de la amenaza",
  threatTriggerSpecieInfoTooltip:"Indique para cada amenaza los elementos desencadenantes que se ven afectados y, cuando sea posible, identifique el alcance y la gravedad de la amenaza en el impacto de cada elemento desencadenante.",
  paste: "Pegar",
  copy: "Copiar",
  onlyForSelectedSpeciesTitle: "Las siguientes selecciones se aplicarán SOLO a esta especie",
  onlyForSelectedTaxonomicTitle: "Las siguientes selecciones se aplicarán a TODAS las especies de esta clase taxonómica",
  onlyForSelectedTaxonomicInfo: "Si todas las especies de esta clase taxonómica son afectadas de manera similar (alcance, gravedad y cronología) por esta amenaza, puede asignar aquí las categorías de alcance y gravedad y serán copiadas a todas las especies de la clase",
  ScopeOfThreatTitle: "Alcance de la amenaza",
  SeverityOfThreatTitle: "Gravedad de la amenaza",
  TimingOfThreatTitle: "Cronología de la amenaza",
  pressureEvaluationHint:'Enumere todas las presiones (amenazas) en el sitio que se considera que afectan los elementos de biodiversidad que activan los criterios y seleccione sus momentos (actual, pasado, futuro, etc.)',
  pressureValidation: "Complete toda la información faltante sobre presión/amenaza antes de enviar la evaluación.",
  taxonDeleteModalTitle: "Eliminar confirmación",
  taxonDeleteModalMessage: "¿Quieres eliminar la clase?",
  speciesDeleteModalMessage: "¿Quieres eliminar especies?",
  ecosystemDeleteModalMessage: "¿Quieres eliminar el ecosistema?",
  bulkDeleteModalTitle: "Confirmación de eliminación masiva",
  bulkSpeciesDeleteModalMessage: "¿Quieres eliminar las especies seleccionadas?",
  bulkEcosystemDeleteModalMessage: "¿Quieres eliminar el ecosistema seleccionado?",
  bulkDeleteToasterConfirmationMessage: "Eliminación masiva completada exitosamente.",
  bulkDeleteToasterFailureMessage: "No se pudieron eliminar los elementos seleccionados.",
  pasteSuccessMessage: "Los elementos seleccionados se pegaron correctamente.",
  pasteFailureMessage: "No se pudieron eliminar los elementos seleccionados.",
  beforeNotSelectBulkItemMessage: "Seleccione los elementos antes de eliminarlos.",
  beforeNotSelectCopyPasteItemMessage: "Seleccione copiar antes de pegar.",
  backToPressureBtnText: "Volver a Presiones",
  triggerSpeciesNoSelectMessage: "Seleccione al menos un elemento.",
  triggerEcosystemNoSelectMessage: "Seleccione al menos un elemento.",
  addTriggerToThisEvaluationBtn: "Añadir disparadores a esta evaluación",
  noTriggerSelectedText: "No hay activadores seleccionados, primero",
monitorYear: 'Año de monitoreo',
numberTriggers: 'Desencadenantes monitoreados',
// monitoringStatus: 'Estado de evaluación',
stateEvaluation: 'Estado completado',
pressureEvaluation: 'Presión completada',
responseEvaluation: 'Respuesta completada',
stateBest: 'Mejor resultado del estado',
stateWorst: 'Peor resultado del estado',
stateMedian: 'Resultado mediano del estado',
pressureBest: 'Mejor resultado de amenazas',
pressureWorst: 'Peor resultado de amenazas',
pressureMedian: 'Resultado mediano de amenazas',
pressureTotal: 'Total de amenazas documentadas',
coveragePa: 'Cobertura por áreas protegidas',
coverageOecm: 'Cobertura por OECM',
coveragePaOecm: 'Cobertura por áreas protegidas y OECM',
managementPlanning: 'Planificación de gestión',
conservationAction: 'Acción de conservación',
actionsNeededUnderwayCount: 'Acciones necesarias y en curso',
actionsNeededCount: 'Acciones necesarias',
actionsUnderway: 'Acciones en curso',

allSpeciesAdded: 'Todas las especies han sido agregadas a la evaluación del estado',
allEcosystemsAdded: 'Todos los ecosistemas han sido agregados a la evaluación del estado',
noRecordsFound: 'No se encontraron registros',
addSpeciesBeforeEcosystems: 'Agrega el/la {type} seleccionado/a antes de agregar {type2}.',
revertSubmission: 'Revertir envío',
monitoringEvaluationRevertConfirmation: '¿Está seguro de que desea revertir esta evaluación de monitoreo?',
viewStateEvaluation: "Abrir evaluación",
addMoreSpecies: 'Agregar especies',
addMoreEcosystems: 'Agregar ecosistemas',
stateEvaluationHint: 'Indique la naturaleza de la evaluación del estado para este desencadenante seleccionando una de las opciones a continuación. Si puede proporcionar una estimación actual para este elemento desencadenante, seleccione la primera opción. Si no tiene datos que respalden una estimación actualizada, puede indicar una categoría de cambio.',
managementPlanningInfo: 'Seleccione la opción que mejor refleje el grado de planificación de la gestión en este sitio.',
enterParameter: 'Ingresar parámetro',
enterDetails: 'Ingresar detalles',
removeMonitoring: 'Eliminar monitoreo',
removeSpeciesModalText: '¿Seguro que desea eliminar a {name} de la lista? Esta acción no se puede deshacer.',
removeEcosystemModalText: '¿Seguro que desea eliminar a {name} de la lista? Esta acción no se puede deshacer.',
onlyForSelectedEcosystemTitle: "Las siguientes selecciones SÓLO se aplicarán a este ecosistema seleccionado",
evaluate: "Evaluar",
Removestate: 'Eliminar elementos de biodiversidad',
isPreviouslyStatedMonitoringParameter: '¿El parámetro de monitoreo indicado anteriormente es correcto?',
isPreviouslyStatedMonitoringParameterTooltip: '¿Desea utilizar el parámetro de monitoreo existente tal como se indica arriba?',
justifyPerameter: 'Justificar parámetro',
justifyPerameterTooltip: 'Por favor proporcione una justificación de por qué se necesita un nuevo valor de referencia. Por ejemplo, ¿el valor es diferente porque el límite del sitio ha sido modificado? ¿O existe una mejor manera de medir el cambio en la abundancia de esta especie a lo largo del tiempo?',
benchmarkPerameterTool: 'Proporcione una estimación para su nuevo valor de referencia seleccionado para esta especie. Asegúrese de que refleje el año base indicado anteriormente. Su valor actualizado se medirá con respecto a este nuevo valor de referencia.',
otherParameter: 'Otro',
enterparameter: 'Ingresar parámetro',



}
export default espanolMX
